(function () {

    var laroute = (function () {

        var routes = {

            absolute: false,
            rootUrl: 'https://qw.staging.ronpos.com',
            routes : [
    {
        "uri": "batcave\/broadcast",
        "name": "admin.broadcast.index"
    },
    {
        "uri": "batcave\/broadcast",
        "name": "admin.broadcast.store"
    },
    {
        "uri": "batcave\/broadcast",
        "name": "admin.broadcast.delete"
    },
    {
        "uri": "batcave\/broadcast\/{broadcast}",
        "name": "admin.broadcast.update"
    },
    {
        "uri": "batcave\/broadcast\/{id}",
        "name": "admin.broadcast.destroy"
    },
    {
        "uri": "batcave\/franchise",
        "name": "admin.franchise.index"
    },
    {
        "uri": "batcave\/franchise\/{id}",
        "name": "admin.franchise.show"
    },
    {
        "uri": "batcave\/franchise\/{id}",
        "name": "admin.franchise.update"
    },
    {
        "uri": "batcave\/franchise\/{id}\/activate",
        "name": "admin.franchise.activate"
    },
    {
        "uri": "batcave\/franchise\/{id}\/central",
        "name": "admin.franchise.show.central"
    },
    {
        "uri": "batcave\/franchise\/{id}\/disable",
        "name": "admin.franchise.disable"
    },
    {
        "uri": "batcave\/franchise\/{id}\/features",
        "name": "admin.franchise.store.features"
    },
    {
        "uri": "batcave\/franchise\/{id}\/impersonate",
        "name": "admin.franchise.impersonate"
    },
    {
        "uri": "batcave\/franchise\/{id}\/outlet",
        "name": "admin.franchise.show.outlet"
    },
    {
        "uri": "batcave\/franchise\/{fid}\/outlet\/{oid}\/details",
        "name": "admin.franchise.outlet.kiosk"
    },
    {
        "uri": "batcave\/franchise\/{id}\/transaction",
        "name": "admin.franchise.transaction.check"
    },
    {
        "uri": "batcave\/franchise\/{id}\/transaction\/{tid}",
        "name": "admin.franchise.transaction.show"
    },
    {
        "uri": "batcave\/franchise\/{id}\/user",
        "name": "admin.franchise.user.index"
    },
    {
        "uri": "batcave\/franchise\/{fid}\/user",
        "name": "admin.franchise.user.store"
    },
    {
        "uri": "batcave\/franchise\/{fid}\/user\/{uid}",
        "name": "admin.franchise.user.update"
    },
    {
        "uri": "batcave\/franchise\/create",
        "name": "admin.franchise.store"
    },
    {
        "uri": "batcave\/franchise\/init\/{franchise}",
        "name": "admin.franchise.init"
    },
    {
        "uri": "batcave\/franchise\/invoices\/{id}",
        "name": "admin.franchise.invoice.list"
    },
    {
        "uri": "batcave\/franchise\/invoices\/{id}\/{invoice_id}",
        "name": "admin.franchise.invoice.download"
    },
    {
        "uri": "batcave\/franchise\/subscription\/{id}",
        "name": "admin.franchise.create.subscription"
    },
    {
        "uri": "batcave\/franchise\/record-payment\/{id}",
        "name": "admin.franchise.invoice.record_payment"
    },
    {
        "uri": "batcave\/franchise\/expiry-date\/{id}",
        "name": "admin.franchise.store.expirydate"
    },
    {
        "uri": "batcave\/franchise\/fuel-rebroadcast\/{id}",
        "name": "admin.franchise.fuel.rebroadcast"
    },
    {
        "uri": "batcave\/franchise\/get-environment-meta",
        "name": "admin.franchise.environment.meta"
    },
    {
        "uri": "batcave\/central-settings",
        "name": "admin.central_settings.index"
    },
    {
        "uri": "batcave\/central-settings\/group\/{id}",
        "name": "admin.central_settings.group.show"
    },
    {
        "uri": "batcave\/central-settings\/group",
        "name": "admin.central_settings.group.create"
    },
    {
        "uri": "batcave\/central-settings\/group\/{id}",
        "name": "admin.central_settings.group.update"
    },
    {
        "uri": "batcave\/central-settings\/group\/update-sequence",
        "name": "admin.central_settings.group.update_sequence"
    },
    {
        "uri": "batcave\/central-settings\/group\/{id}",
        "name": "admin.central_settings.group.delete"
    },
    {
        "uri": "batcave\/user",
        "name": "admin.user.index"
    },
    {
        "uri": "batcave\/user\/create",
        "name": "admin.user.create"
    },
    {
        "uri": "batcave\/user\/{id}\/impersonate",
        "name": "admin.user.impersonate"
    },
    {
        "uri": "batcave\/user\/{id}\/unlock",
        "name": "admin.user.unlock"
    },
    {
        "uri": "batcave\/timezone",
        "name": "admin.timezone"
    },
    {
        "uri": "batcave\/currency",
        "name": "admin.currency"
    },
    {
        "uri": "api\/batcave\/query",
        "name": "admin.query"
    },
    {
        "uri": "franchise\/category",
        "name": "franchise.inventory.category.store"
    },
    {
        "uri": "franchise\/modifier",
        "name": "franchise.inventory.modifier.store"
    },
    {
        "uri": "franchise\/pricebook",
        "name": "franchise.inventory.pricebook.index"
    },
    {
        "uri": "franchise\/pricebook",
        "name": "franchise.inventory.pricebook.store"
    },
    {
        "uri": "franchise\/pricebook\/{id}",
        "name": "franchise.inventory.pricebook.show"
    },
    {
        "uri": "logout",
        "name": "loyalty.logout"
    },
    {
        "uri": "login",
        "name": "loyalty.login"
    },
    {
        "uri": "login",
        "name": "loyalty.login_attempt"
    },
    {
        "uri": "login\/{phone}\/pwd",
        "name": "loyalty.login_pwd"
    },
    {
        "uri": "check-credential",
        "name": "loyalty.check_credential"
    },
    {
        "uri": "request-code",
        "name": "loyalty.request_code"
    },
    {
        "uri": "confirmation",
        "name": "loyalty.confirmation"
    },
    {
        "uri": "verify-code",
        "name": "loyalty.verify_code"
    },
    {
        "uri": "set-password",
        "name": "loyalty.set_password"
    },
    {
        "uri": "set-password",
        "name": "loyalty.save_password"
    },
    {
        "uri": "\/",
        "name": "loyalty.index"
    },
    {
        "uri": "auth",
        "name": "loyalty.auth"
    },
    {
        "uri": "my-rewards",
        "name": "loyalty.my_rewards"
    },
    {
        "uri": "change-pwd",
        "name": "loyalty.change_pwd"
    },
    {
        "uri": "c\/{hash}",
        "name": "loyalty.customer.confirm"
    },
    {
        "uri": "r\/{hash}",
        "name": "loyalty.redemption"
    },
    {
        "uri": "t\/{hash}",
        "name": "loyalty.receipt"
    },
    {
        "uri": "login",
        "name": "login"
    },
    {
        "uri": "signup\/account-setup",
        "name": "signup.account_setup.store"
    },
    {
        "uri": "franchise\/central-settings",
        "name": "franchise.outlet_central_settings.index"
    },
    {
        "uri": "franchise\/central-settings\/list",
        "name": "franchise.outlet_central_settings.list"
    },
    {
        "uri": "franchise\/tag",
        "name": "franchise.inventory.tags.index"
    },
    {
        "uri": "franchise\/tag\/product",
        "name": "franchise.inventory.tags.index.tag-product"
    },
    {
        "uri": "franchise\/tag\/vue\/tag",
        "name": "franchise.inventory.tags.vue.getvuetabletag"
    },
    {
        "uri": "franchise\/tag\/show\/{id}",
        "name": "franchise.inventory.tags.show"
    },
    {
        "uri": "franchise\/tag\/export\/{type}",
        "name": "franchise.inventory.tags.exportAsFile"
    },
    {
        "uri": "franchise\/tag\/tree",
        "name": "franchise.inventory.tags.tree"
    },
    {
        "uri": "franchise\/tag\/update\/{id}",
        "name": "franchise.inventory.tags.update"
    },
    {
        "uri": "franchise\/tag\/store",
        "name": "franchise.inventory.tags.store"
    },
    {
        "uri": "franchise\/tag\/delete",
        "name": "franchise.inventory.tags.delete"
    },
    {
        "uri": "franchise\/tag\/toggle-status",
        "name": "franchise.inventory.tags.toggle-status"
    },
    {
        "uri": "franchise\/shelf-space-plan",
        "name": "franchise.shelf_space_plan.index"
    },
    {
        "uri": "franchise\/shelf-space-plan\/{id}",
        "name": "franchise.shelf_space_plan.show"
    },
    {
        "uri": "franchise\/shelf-space-plan\/list",
        "name": "franchise.shelf_space_plan.list"
    },
    {
        "uri": "franchise\/shelf-space-plan\/{id}\/products",
        "name": "franchise.shelf_space_plan.products"
    },
    {
        "uri": "franchise\/shelf-space-plan\/{id}\/products-pool",
        "name": "franchise.shelf_space_plan.products_pool"
    },
    {
        "uri": "franchise\/shelf-space-plan\/{id}\/products-count",
        "name": "franchise.shelf_space_plan.products_count"
    },
    {
        "uri": "franchise\/shelf-space-plan\/category",
        "name": "franchise.shelf_space_plan.category"
    },
    {
        "uri": "franchise\/shelf-space-plan\/sub-category",
        "name": "franchise.shelf_space_plan.sub_category"
    },
    {
        "uri": "franchise\/shelf-space-plan\/count",
        "name": "franchise.shelf_space_plan.count"
    },
    {
        "uri": "franchise\/shelf-space-plan\/export\/{type}",
        "name": "franchise.shelf_space_plan.exportAsFile"
    },
    {
        "uri": "franchise\/shelf-space-plan\/create",
        "name": "franchise.shelf_space_plan.create"
    },
    {
        "uri": "franchise\/shelf-space-plan\/delete",
        "name": "franchise.shelf_space_plan.delete"
    },
    {
        "uri": "franchise\/shelf-space-plan\/products-create",
        "name": "franchise.shelf_space_plan.products_create"
    },
    {
        "uri": "franchise\/shelf-space-plan\/products-delete",
        "name": "franchise.shelf_space_plan.products_delete"
    },
    {
        "uri": "franchise\/shelf-space-plan\/import",
        "name": "franchise.shelf_space_plan.import"
    },
    {
        "uri": "franchise\/shelf-space-plan\/validate\/{importKey}",
        "name": "franchise.shelf_space_plan.validate_data"
    },
    {
        "uri": "franchise\/shelf-space-plan\/store\/{importKey}",
        "name": "franchise.shelf_space_plan.store_data"
    },
    {
        "uri": "franchise\/shelf-space-plan\/read-data\/{importKey}",
        "name": "franchise.shelf_space_plan.read_data"
    },
    {
        "uri": "franchise\/shelf-space-plan\/import-status\/{importKey}",
        "name": "franchise.shelf_space_plan.import_status"
    },
    {
        "uri": "franchise\/localaccount",
        "name": "franchise.localaccount.main"
    },
    {
        "uri": "franchise\/localaccount\/fuels",
        "name": "franchise.localaccount.fuels"
    },
    {
        "uri": "franchise\/localaccount\/{outletId}",
        "name": "franchise.localaccount.index"
    },
    {
        "uri": "franchise\/localaccount\/{outletId}\/list\/{accountId}",
        "name": "franchise.localaccount.onaccount.total"
    },
    {
        "uri": "franchise\/localaccount\/{outletId}\/summary",
        "name": "franchise.localaccount.summary"
    },
    {
        "uri": "franchise\/localaccount\/{id}\/show\/{account_id}",
        "name": "franchise.localaccount.show"
    },
    {
        "uri": "franchise\/localaccount\/import\/{outletId}\/list",
        "name": "franchise.localaccount.import.list"
    },
    {
        "uri": "franchise\/localaccount\/import\/{outletId}\/vehicle\/{accountId}\/list",
        "name": "franchise.localaccount.import.vehicle.list"
    },
    {
        "uri": "franchise\/localaccount\/export\/{type}",
        "name": "franchise.localaccount.exportTemplate"
    },
    {
        "uri": "franchise\/localaccount\/export-vehicle\/{type}",
        "name": "franchise.localaccount.exportVehicleTemplate"
    },
    {
        "uri": "franchise\/localaccount",
        "name": "franchise.localaccount.store"
    },
    {
        "uri": "franchise\/localaccount\/import\/{outlet_id}",
        "name": "franchise.localaccount.import.account"
    },
    {
        "uri": "franchise\/localaccount\/import\/{outlet_id}\/vehicle\/{account_id}",
        "name": "franchise.localaccount.import.vehicle.account"
    },
    {
        "uri": "franchise\/localaccount\/{outletId}\/delete\/{userId}",
        "name": "franchise.localaccount.delete"
    },
    {
        "uri": "franchise\/localaccount\/{outletId}\/user\/{userId}",
        "name": "franchise.localaccount.update"
    },
    {
        "uri": "franchise\/localaccount\/exportoverallsummary\/{outletId}\/{type}",
        "name": "franchise.localaccount.exportoverallsummary"
    },
    {
        "uri": "franchise\/tank",
        "name": "franchise.inventory.tank.index"
    },
    {
        "uri": "franchise\/tank\/api\/dipping\/tank\/{id}\/latest",
        "name": "franchise.inventory.tank.dipping.latest"
    },
    {
        "uri": "franchise\/tank\/api\/receiving\/tank\/{id}\/latest",
        "name": "franchise.inventory.tank.receiving.latest"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/{id}\/graph\/entry",
        "name": "franchise.inventory.tank.graph.entry"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/group\/{id}\/graph\/entry",
        "name": "franchise.inventory.tank.group.graph.entry"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/count",
        "name": "franchise.inventory.tank.search.count"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/meta",
        "name": "franchise.inventory.tank.search.meta"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank",
        "name": "franchise.inventory.tank.search"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/group\/count",
        "name": "franchise.inventory.tank.group.search.count"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/group\/meta",
        "name": "franchise.inventory.tank.group.search.meta"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/group",
        "name": "franchise.inventory.tank.group.search"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/{id}",
        "name": "franchise.inventory.tank.show"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/{id}\/balance",
        "name": "franchise.inventory.tank.balance"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/autocomplete",
        "name": "franchise.inventory.tank.vue.tank"
    },
    {
        "uri": "franchise\/tank\/api\/search\/tank\/group\/autocomplete",
        "name": "franchise.inventory.tank.vue.tank-group"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/outlet\/{id}",
        "name": "franchise.inventory.tank.outlet"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/{id}",
        "name": "franchise.inventory.tank.update"
    },
    {
        "uri": "franchise\/tank\/api\/tank\/export",
        "name": "franchise.inventory.tank.export"
    },
    {
        "uri": "franchise\/charge",
        "name": "franchise.inventory.charge.index"
    },
    {
        "uri": "franchise\/charge\/{id}",
        "name": "franchise.inventory.charge.show"
    },
    {
        "uri": "franchise\/charge\/export\/{type}",
        "name": "franchise.inventory.charge.exportAsFile"
    },
    {
        "uri": "franchise\/charge",
        "name": "franchise.inventory.charge.store"
    },
    {
        "uri": "franchise\/charge",
        "name": "franchise.inventory.charge.delete"
    },
    {
        "uri": "franchise\/charge\/{id}",
        "name": "franchise.inventory.charge.update"
    },
    {
        "uri": "franchise\/audit-trail",
        "name": "franchise.audit-trail.index"
    },
    {
        "uri": "franchise\/audit-trail\/show",
        "name": "franchise.audit-trail.show"
    },
    {
        "uri": "franchise\/audit-trail\/export",
        "name": "franchise.audit-trail.exportDetail"
    },
    {
        "uri": "franchise\/audit-trail\/export-audit\/{type}",
        "name": "franchise.audit-trail.export"
    },
    {
        "uri": "franchise\/audit-trail\/api\/audit\/list",
        "name": "franchise.audit-trail.list"
    },
    {
        "uri": "franchise\/audit-trail\/api\/audit\/meta",
        "name": "franchise.audit-trail.meta"
    },
    {
        "uri": "franchise\/audit-trail\/product",
        "name": "franchise.audit-trail.product"
    },
    {
        "uri": "franchise\/audit-trail\/product\/list",
        "name": "franchise.audit-trail.productList"
    },
    {
        "uri": "franchise\/audit-trail\/product\/export-audit\/{type}",
        "name": "franchise.audit-trail.product-export"
    },
    {
        "uri": "franchise\/audit-trail\/product\/export",
        "name": "franchise.audit-trail.product-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/tax",
        "name": "franchise.audit-trail.tax"
    },
    {
        "uri": "franchise\/audit-trail\/tax\/list",
        "name": "franchise.audit-trail.taxList"
    },
    {
        "uri": "franchise\/audit-trail\/tax\/export-audit\/{type}",
        "name": "franchise.audit-trail.tax-export"
    },
    {
        "uri": "franchise\/audit-trail\/tax\/export",
        "name": "franchise.audit-trail.tax-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/charge",
        "name": "franchise.audit-trail.charge"
    },
    {
        "uri": "franchise\/audit-trail\/charge\/list",
        "name": "franchise.audit-trail.chargeList"
    },
    {
        "uri": "franchise\/audit-trail\/charge\/export-audit\/{type}",
        "name": "franchise.audit-trail.charge-export"
    },
    {
        "uri": "franchise\/audit-trail\/charge\/export",
        "name": "franchise.audit-trail.charge-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/label",
        "name": "franchise.audit-trail.label"
    },
    {
        "uri": "franchise\/audit-trail\/label\/list",
        "name": "franchise.audit-trail.labelList"
    },
    {
        "uri": "franchise\/audit-trail\/label\/export-audit\/{type}",
        "name": "franchise.audit-trail.label-export"
    },
    {
        "uri": "franchise\/audit-trail\/label\/export",
        "name": "franchise.audit-trail.label-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/fuel-price",
        "name": "franchise.audit-trail.fuel-price"
    },
    {
        "uri": "franchise\/audit-trail\/fuel-price\/list",
        "name": "franchise.audit-trail.fuel-price-list"
    },
    {
        "uri": "franchise\/audit-trail\/fuel-price\/export-audit\/{type}",
        "name": "franchise.audit-trail.fuel-price-export"
    },
    {
        "uri": "franchise\/audit-trail\/fuel-price\/export",
        "name": "franchise.audit-trail.fuel-price-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/promotion",
        "name": "franchise.audit-trail.promotion"
    },
    {
        "uri": "franchise\/audit-trail\/promotion\/list",
        "name": "franchise.audit-trail.promotion-list"
    },
    {
        "uri": "franchise\/audit-trail\/promotion\/export-audit\/{type}",
        "name": "franchise.audit-trail.promotion-export"
    },
    {
        "uri": "franchise\/audit-trail\/promotion\/export",
        "name": "franchise.audit-trail.promotion-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/main-pricebook",
        "name": "franchise.audit-trail.main-pricebook"
    },
    {
        "uri": "franchise\/audit-trail\/main-pricebook\/list",
        "name": "franchise.audit-trail.main-pricebook-list"
    },
    {
        "uri": "franchise\/audit-trail\/main-pricebook\/export-audit\/{type}",
        "name": "franchise.audit-trail.main-pricebook-export"
    },
    {
        "uri": "franchise\/audit-trail\/main-pricebook\/export",
        "name": "franchise.audit-trail.main-pricebook-export-detail"
    },
    {
        "uri": "franchise\/audit-trail\/station-pricebook",
        "name": "franchise.audit-trail.station-pricebook"
    },
    {
        "uri": "franchise\/audit-trail\/station-pricebook\/list",
        "name": "franchise.audit-trail.station-pricebook-list"
    },
    {
        "uri": "franchise\/audit-trail\/station-pricebook\/export-audit\/{type}",
        "name": "franchise.audit-trail.station-pricebook-export"
    },
    {
        "uri": "franchise\/audit-trail\/station-pricebook\/export",
        "name": "franchise.audit-trail.station-pricebook-export-detail"
    },
    {
        "uri": "franchise\/custom-receipt",
        "name": "franchise.custom.receipt.index"
    },
    {
        "uri": "franchise\/custom-receipt\/meta",
        "name": "franchise.custom.receipt.meta"
    },
    {
        "uri": "franchise\/custom-receipt\/save",
        "name": "franchise.custom.receipt.save"
    },
    {
        "uri": "franchise\/category",
        "name": "franchise.inventory.category.index"
    },
    {
        "uri": "franchise\/category\/{id}",
        "name": "franchise.inventory.category.show"
    },
    {
        "uri": "franchise\/category\/export\/{type}",
        "name": "franchise.inventory.category.export"
    },
    {
        "uri": "franchise\/category",
        "name": "franchise.inventory.category.delete"
    },
    {
        "uri": "franchise\/category\/{id}",
        "name": "franchise.inventory.category.update"
    },
    {
        "uri": "franchise\/customer",
        "name": "franchise.customers.index"
    },
    {
        "uri": "franchise\/customer\/all",
        "name": "franchise.customers.all"
    },
    {
        "uri": "franchise\/customer\/summary",
        "name": "franchise.customers.summary"
    },
    {
        "uri": "franchise\/customer\/transaction\/{id}",
        "name": "franchise.customers.transaction_details"
    },
    {
        "uri": "franchise\/customer\/{id}",
        "name": "franchise.customers.show"
    },
    {
        "uri": "franchise\/customer\/{id}\/transactions",
        "name": "franchise.customers.transactions"
    },
    {
        "uri": "franchise\/customer\/profile\/{id}",
        "name": "franchise.customers.profile"
    },
    {
        "uri": "franchise\/customer\/export-customers\/{type}",
        "name": "franchise.customers.export_customers"
    },
    {
        "uri": "franchise\/customer\/{id}\/export-transactions\/{type}",
        "name": "franchise.customers.export_trans"
    },
    {
        "uri": "franchise\/trading_area",
        "name": "franchise.trading_area.index"
    },
    {
        "uri": "franchise\/trading_area\/{id}",
        "name": "franchise.trading_area.show"
    },
    {
        "uri": "franchise\/trading_area",
        "name": "franchise.trading_area.store"
    },
    {
        "uri": "franchise\/trading_area",
        "name": "franchise.trading_area.delete"
    },
    {
        "uri": "franchise\/trading_area\/{id}",
        "name": "franchise.trading_area.update"
    },
    {
        "uri": "franchise\/ewallet",
        "name": "franchise.setting.ewallet.index"
    },
    {
        "uri": "franchise\/ewallet",
        "name": "franchise.setting.ewallet.store"
    },
    {
        "uri": "franchise\/ewallet\/{id}",
        "name": "franchise.setting.ewallet.update"
    },
    {
        "uri": "franchise\/staff\/role",
        "name": "franchise.staff.role.index"
    },
    {
        "uri": "franchise\/staff\/role\/store",
        "name": "franchise.staff.role.store"
    },
    {
        "uri": "franchise\/staff\/role\/{id}",
        "name": "franchise.staff.role.update"
    },
    {
        "uri": "franchise\/staff\/role\/delete",
        "name": "franchise.staff.role.delete"
    },
    {
        "uri": "franchise\/device",
        "name": "franchise.setting.device.index"
    },
    {
        "uri": "franchise\/device\/{id}",
        "name": "franchise.setting.device.show"
    },
    {
        "uri": "franchise\/device\/export\/{type}",
        "name": "franchise.setting.device.exportAsFile"
    },
    {
        "uri": "franchise\/device\/generateNewCode",
        "name": "franchise.setting.device.generateNewCode"
    },
    {
        "uri": "franchise\/device\/getDeviceList",
        "name": "franchise.setting.device.getDeviceList"
    },
    {
        "uri": "franchise\/device",
        "name": "franchise.setting.device.store"
    },
    {
        "uri": "franchise\/device\/{id}",
        "name": "franchise.setting.device.update"
    },
    {
        "uri": "franchise\/device\/{id}",
        "name": "franchise.setting.device.delete"
    },
    {
        "uri": "franchise\/authorised\/{id}\/list\/{account_id}",
        "name": "franchise.authorised.index"
    },
    {
        "uri": "franchise\/authorised\/{id}\/show\/{vehicle_id}",
        "name": "franchise.authorised.show"
    },
    {
        "uri": "franchise\/authorised\/{outletId}\/account\/{userId}",
        "name": "franchise.authorised.store"
    },
    {
        "uri": "franchise\/authorised\/{id}\/delete\/{account_id}\/status\/{status}",
        "name": "franchise.authorised.delete"
    },
    {
        "uri": "franchise\/authorised\/{outletId}\/deletevehicle\/{id}",
        "name": "franchise.authorised.deletevehicle"
    },
    {
        "uri": "franchise\/authorised\/{outletId}\/account\/{vehicle_id}",
        "name": "franchise.authorised.update"
    },
    {
        "uri": "franchise\/authorised\/{client_id}\/export\/{user_id}\/{type}",
        "name": "franchise.authorised.export"
    },
    {
        "uri": "franchise\/authorised\/export-qrcode",
        "name": "franchise.authorised.exportQrCode"
    },
    {
        "uri": "franchise\/report-wizard",
        "name": "franchise.report-wizard.index"
    },
    {
        "uri": "franchise\/report-wizard\/info",
        "name": "franchise.report-wizard.info"
    },
    {
        "uri": "franchise\/report-wizard\/export",
        "name": "franchise.report-wizard.export"
    },
    {
        "uri": "franchise\/report-wizard\/category",
        "name": "franchise.report-wizard.category"
    },
    {
        "uri": "franchise\/report-wizard\/sub_category",
        "name": "franchise.report-wizard.sub-category"
    },
    {
        "uri": "franchise\/report-wizard\/saved-settings",
        "name": "franchise.report-wizard.saved-settings"
    },
    {
        "uri": "franchise\/report-wizard\/create-saved-settings",
        "name": "franchise.report-wizard.create-saved-settings"
    },
    {
        "uri": "franchise\/report-wizard\/delete-saved-settings",
        "name": "franchise.report-wizard.delete-saved-settings"
    },
    {
        "uri": "franchise\/payment",
        "name": "franchise.setting.payment.index"
    },
    {
        "uri": "franchise\/payment\/{id}",
        "name": "franchise.setting.payment.show"
    },
    {
        "uri": "franchise\/payment\/{source}",
        "name": "franchise.setting.payment.show.source"
    },
    {
        "uri": "franchise\/payment",
        "name": "franchise.setting.payment.store"
    },
    {
        "uri": "franchise\/payment\/{id}",
        "name": "franchise.setting.payment.update"
    },
    {
        "uri": "franchise\/payment",
        "name": "franchise.setting.payment.delete"
    },
    {
        "uri": "franchise\/voucher",
        "name": "franchise.inventory.coupon.index"
    },
    {
        "uri": "franchise\/voucher\/redemptions",
        "name": "franchise.inventory.coupon.redemptions"
    },
    {
        "uri": "franchise\/voucher\/invoices",
        "name": "franchise.inventory.coupon.invoices"
    },
    {
        "uri": "franchise\/voucher\/{id}",
        "name": "franchise.inventory.coupon.show"
    },
    {
        "uri": "franchise\/voucher\/export\/{type}",
        "name": "franchise.inventory.coupon.exportAsFile"
    },
    {
        "uri": "franchise\/voucher",
        "name": "franchise.inventory.coupon.store"
    },
    {
        "uri": "franchise\/voucher\/{id}",
        "name": "franchise.inventory.coupon.update"
    },
    {
        "uri": "franchise\/voucher\/{outlet_id?}",
        "name": "franchise.inventory.coupon.delete"
    },
    {
        "uri": "franchise\/voucher\/addMedia",
        "name": "franchise.inventory.coupon.addmedia"
    },
    {
        "uri": "franchise\/station_changeset",
        "name": "franchise.station_changeset.index"
    },
    {
        "uri": "franchise\/station_changeset\/{id}",
        "name": "franchise.station_changeset.show"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/products\/{station}",
        "name": "franchise.station_changeset.products"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/stations",
        "name": "franchise.station_changeset.stations"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/station\/{station}",
        "name": "franchise.station_changeset.station"
    },
    {
        "uri": "franchise\/station_changeset\/edit\/{id}\/station\/{station}",
        "name": "franchise.station_changeset.edit"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/export\/{type}\/products",
        "name": "franchise.station_changeset.export.products"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/export\/{type}\/stations",
        "name": "franchise.station_changeset.export.stations"
    },
    {
        "uri": "franchise\/station_changeset\/{id}",
        "name": "franchise.station_changeset.update"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/publish",
        "name": "franchise.station_changeset.publish"
    },
    {
        "uri": "franchise\/station_changeset",
        "name": "franchise.station_changeset.store"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/approval\/{status}\/station\/{station}",
        "name": "franchise.station_changeset.approval"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/products",
        "name": "franchise.station_changeset.deleteProduct"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/changeset",
        "name": "franchise.station_changeset.deleteChangeset"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/products_pool",
        "name": "franchise.station_changeset.products_pool"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/products_count",
        "name": "franchise.station_changeset.products_count"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/batch_add",
        "name": "franchise.station_changeset.batch_add"
    },
    {
        "uri": "franchise\/station_changeset\/{id}\/entry",
        "name": "franchise.station_changeset.entry.save"
    },
    {
        "uri": "franchise\/vue\/auth",
        "name": "franchise.vue.auth_user"
    },
    {
        "uri": "franchise\/vue\/categories",
        "name": "franchise.vue.categories"
    },
    {
        "uri": "franchise\/vue\/centrals",
        "name": "franchise.vue.centrals"
    },
    {
        "uri": "franchise\/vue\/checkouts",
        "name": "franchise.vue.checkouts"
    },
    {
        "uri": "franchise\/vue\/discounts",
        "name": "franchise.vue.discounts"
    },
    {
        "uri": "franchise\/vue\/fuels",
        "name": "franchise.vue.fuels"
    },
    {
        "uri": "franchise\/vue\/modifiersets",
        "name": "franchise.vue.getmodifiersetsselect"
    },
    {
        "uri": "franchise\/vue\/outlets",
        "name": "franchise.vue.outlets"
    },
    {
        "uri": "franchise\/vue\/payments",
        "name": "franchise.vue.payments"
    },
    {
        "uri": "franchise\/vue\/products",
        "name": "franchise.vue.products"
    },
    {
        "uri": "franchise\/vue\/promotions",
        "name": "franchise.vue.promotions"
    },
    {
        "uri": "franchise\/vue\/clone\/promotions",
        "name": "franchise.vue.clone.promotions"
    },
    {
        "uri": "franchise\/vue\/roles",
        "name": "franchise.vue.roles"
    },
    {
        "uri": "franchise\/vue\/regions",
        "name": "franchise.vue.regions"
    },
    {
        "uri": "franchise\/vue\/shifts",
        "name": "franchise.vue.shifts"
    },
    {
        "uri": "franchise\/vue\/tags",
        "name": "franchise.vue.tags"
    },
    {
        "uri": "franchise\/vue\/parent-tags",
        "name": "franchise.vue.parent.tags"
    },
    {
        "uri": "franchise\/vue\/taxes",
        "name": "franchise.vue.gettaxselect"
    },
    {
        "uri": "franchise\/vue\/targets",
        "name": "franchise.vue.getTargetList"
    },
    {
        "uri": "franchise\/vue\/users",
        "name": "franchise.vue.users"
    },
    {
        "uri": "franchise\/vue\/variants",
        "name": "franchise.vue.variants"
    },
    {
        "uri": "franchise\/vue\/account",
        "name": "franchise.vue.account"
    },
    {
        "uri": "franchise\/vue\/staffs",
        "name": "franchise.vue.staffs"
    },
    {
        "uri": "franchise\/vue\/tiers",
        "name": "franchise.vue.tiers"
    },
    {
        "uri": "franchise\/vue\/states",
        "name": "franchise.vue.states"
    },
    {
        "uri": "franchise\/vue\/zone",
        "name": "franchise.vue.zone"
    },
    {
        "uri": "franchise\/vue\/trading-area",
        "name": "franchise.vue.trading_area"
    },
    {
        "uri": "franchise\/vue\/pricebook",
        "name": "franchise.vue.pricebook"
    },
    {
        "uri": "franchise\/vue\/outlet_pricebook",
        "name": "franchise.vue.outlet_pricebook"
    },
    {
        "uri": "franchise\/vue\/override-pricebook",
        "name": "franchise.vue.override.pricebook"
    },
    {
        "uri": "franchise\/vue\/receipt-promotion",
        "name": "franchise.vue.get.promotions"
    },
    {
        "uri": "franchise\/vue\/timezone",
        "name": "franchise.vue.timezone"
    },
    {
        "uri": "franchise\/vue\/currency",
        "name": "franchise.vue.currency"
    },
    {
        "uri": "franchise\/vue\/labels",
        "name": "franchise.vue.labels"
    },
    {
        "uri": "franchise\/vue\/tags\/dropdown",
        "name": "franchise.vue.tags.dropdown"
    },
    {
        "uri": "franchise\/vue\/cards",
        "name": "franchise.vue.cards"
    },
    {
        "uri": "franchise\/vue\/eps-cards",
        "name": "franchise.vue.epsCards"
    },
    {
        "uri": "franchise\/vue\/shell-app-cards",
        "name": "franchise.vue.shellAppCards"
    },
    {
        "uri": "franchise\/vue\/ewallet",
        "name": "franchise.vue.ewallet"
    },
    {
        "uri": "franchise\/dashboard\/broadcast\/seen\/{broadcast}",
        "name": "franchise.dashboard.broadcast.seen"
    },
    {
        "uri": "franchise\/dashboard\/stats",
        "name": "franchise.dashboard.stats"
    },
    {
        "uri": "franchise\/dashboard\/target-sales",
        "name": "franchise.dashboard.getMonthlyTargetSales"
    },
    {
        "uri": "franchise\/dashboard\/export\/{type}",
        "name": "franchise.dashboard.exportStatsAsCSV"
    },
    {
        "uri": "franchise\/dashboard\/proxy\/{key}",
        "name": "franchise.dashboard.proxy"
    },
    {
        "uri": "franchise\/dashboard\/proxy\/{key}",
        "name": "franchise.dashboard.proxy"
    },
    {
        "uri": "franchise\/dashboard\/fuel\/tanks\/{outlet_id}\/{type}\/{value?}",
        "name": "franchise.dashboard.fuel.tanks"
    },
    {
        "uri": "franchise\/dashboard\/fuel\/sales\/eod\/{outlet_id}\/{type}",
        "name": "franchise.dashboard.fuel.sales.eod"
    },
    {
        "uri": "franchise\/dashboard\/fuel\/average\/spending\/receipt\/{outlet_id}\/{type}",
        "name": "franchise.dashboard.fuel.averageSpendingReceipt"
    },
    {
        "uri": "franchise\/dashboard\/fuel\/evaporation\/{outlet_id}\/{type}",
        "name": "franchise.dashboard.fuel.evaporation"
    },
    {
        "uri": "franchise\/myaccount",
        "name": "franchise.myaccount.index"
    },
    {
        "uri": "franchise\/myaccount\/account",
        "name": "franchise.myaccount.account"
    },
    {
        "uri": "franchise\/myaccount\/subscription-items",
        "name": "franchise.myaccount.subscription_items"
    },
    {
        "uri": "franchise\/myaccount\/create-session",
        "name": "franchise.myaccount.create_session"
    },
    {
        "uri": "franchise\/myaccount\/checkout-trial",
        "name": "franchise.myaccount.checkout_trial"
    },
    {
        "uri": "franchise\/myaccount\/checkout-plan",
        "name": "franchise.myaccount.checkout_plan"
    },
    {
        "uri": "franchise\/myaccount\/checkout-success\/{hosted_page_id}",
        "name": "franchise.myaccount.checkout_success"
    },
    {
        "uri": "franchise\/myaccount\/resync-subscription",
        "name": "franchise.myaccount.resync_subscription"
    },
    {
        "uri": "franchise\/myaccount\/franchise-media",
        "name": "franchise.myaccount.franchise_media"
    },
    {
        "uri": "franchise\/myaccount\/franchise",
        "name": "franchise.myaccount.update_franchise"
    },
    {
        "uri": "franchise\/myaccount\/invoice",
        "name": "franchise.myaccount.invoice.index"
    },
    {
        "uri": "franchise\/myaccount\/invoice\/download\/{id}",
        "name": "franchise.myaccount.invoice.download"
    },
    {
        "uri": "franchise\/loyalty\/redemption",
        "name": "franchise.loyalty.redemption.index"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/{id}",
        "name": "franchise.loyalty.redemption.show"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/eligibility",
        "name": "franchise.loyalty.redemption.eligibility_count"
    },
    {
        "uri": "franchise\/loyalty\/settings",
        "name": "franchise.loyalty.settings.index"
    },
    {
        "uri": "franchise\/loyalty\/sms\/balance",
        "name": "franchise.loyalty.sms.balance"
    },
    {
        "uri": "franchise\/loyalty\/sms\/packages",
        "name": "franchise.loyalty.sms.packages"
    },
    {
        "uri": "franchise\/loyalty\/sms\/payment-confirmed",
        "name": "franchise.loyalty.sms.payment_confirmed"
    },
    {
        "uri": "franchise\/loyalty\/redemption",
        "name": "franchise.loyalty.redemption.store"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/{id}",
        "name": "franchise.loyalty.redemption.update"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/delete",
        "name": "franchise.loyalty.redemption.bulkdelete"
    },
    {
        "uri": "franchise\/loyalty\/redemption\/update",
        "name": "franchise.loyalty.redemption.bulkupdate"
    },
    {
        "uri": "franchise\/loyalty\/settings",
        "name": "franchise.loyalty.settings.update"
    },
    {
        "uri": "franchise\/loyalty\/sms\/packages\/{id}\/bill",
        "name": "franchise.loyalty.sms.package_bill"
    },
    {
        "uri": "franchise\/loyalty\/payment-confirmed",
        "name": "franchise.loyalty.sms.payment_confirmed"
    },
    {
        "uri": "franchise\/subsidy",
        "name": "franchise.setting.subsidy.index"
    },
    {
        "uri": "franchise\/subsidy\/list",
        "name": "franchise.setting.subsidy.list"
    },
    {
        "uri": "franchise\/subsidy",
        "name": "franchise.setting.subsidy.store"
    },
    {
        "uri": "franchise\/subsidy\/{id}",
        "name": "franchise.setting.subsidy.update"
    },
    {
        "uri": "franchise\/modifier",
        "name": "franchise.inventory.modifier.index"
    },
    {
        "uri": "franchise\/modifier\/{id}",
        "name": "franchise.inventory.modifier.show"
    },
    {
        "uri": "franchise\/modifier\/export\/{type}",
        "name": "franchise.inventory.modifier.exportAsFile"
    },
    {
        "uri": "franchise\/modifier\/{id}",
        "name": "franchise.inventory.modifier.update"
    },
    {
        "uri": "franchise\/modifier",
        "name": "franchise.inventory.modifier.delete"
    },
    {
        "uri": "franchise\/product\/search\/meta",
        "name": "franchise.inventory.item.search.meta"
    },
    {
        "uri": "franchise\/product",
        "name": "franchise.inventory.item.index"
    },
    {
        "uri": "franchise\/product\/{id}",
        "name": "franchise.inventory.item.show"
    },
    {
        "uri": "franchise\/product\/export\/{type}",
        "name": "franchise.inventory.item.exportAsFile"
    },
    {
        "uri": "franchise\/product",
        "name": "franchise.inventory.item.store"
    },
    {
        "uri": "franchise\/product\/{id}",
        "name": "franchise.inventory.item.update"
    },
    {
        "uri": "franchise\/product\/{outlet_id?}",
        "name": "franchise.inventory.item.delete"
    },
    {
        "uri": "franchise\/product\/media",
        "name": "franchise.inventory.item.addmedia"
    },
    {
        "uri": "franchise\/product\/import",
        "name": "franchise.inventory.item.import"
    },
    {
        "uri": "franchise\/product\/validate\/{importKey}",
        "name": "franchise.inventory.item.validate_data"
    },
    {
        "uri": "franchise\/product\/store\/{importKey}",
        "name": "franchise.inventory.item.store_data"
    },
    {
        "uri": "franchise\/product\/read-data\/{importKey}",
        "name": "franchise.inventory.item.readdata"
    },
    {
        "uri": "franchise\/product\/update",
        "name": "franchise.inventory.item.bulkUpdate"
    },
    {
        "uri": "franchise\/product\/import-status\/{importKey}",
        "name": "franchise.inventory.item.import_status"
    },
    {
        "uri": "franchise\/hub-settings",
        "name": "franchise.hub_settings.index"
    },
    {
        "uri": "franchise\/hub-settings\/{id}",
        "name": "franchise.hub_settings.show"
    },
    {
        "uri": "franchise\/hub-settings\/list",
        "name": "franchise.hub_settings.list"
    },
    {
        "uri": "franchise\/hub-settings\/list-global",
        "name": "franchise.hub_settings.list-global"
    },
    {
        "uri": "franchise\/hub-settings\/detail\/{id}",
        "name": "franchise.hub_settings.detail"
    },
    {
        "uri": "franchise\/hub-settings\/detail\/{id}\/global",
        "name": "franchise.hub_settings.detail-global"
    },
    {
        "uri": "franchise\/hub-settings\/{outlet_id}\/detail\/{id}",
        "name": "franchise.hub_settings.edit"
    },
    {
        "uri": "franchise\/hub-settings\/{outlet_id}\/show\/{id}",
        "name": "franchise.hub_settings.value"
    },
    {
        "uri": "franchise\/hub-settings\/show\/{id}",
        "name": "franchise.hub_settings.show-global"
    },
    {
        "uri": "franchise\/hub-settings",
        "name": "franchise.hub_settings.store"
    },
    {
        "uri": "franchise\/hub-settings",
        "name": "franchise.hub_settings.update"
    },
    {
        "uri": "franchise\/hub-settings\/global",
        "name": "franchise.hub_settings.update-global"
    },
    {
        "uri": "franchise\/hub-settings",
        "name": "franchise.hub_settings.delete"
    },
    {
        "uri": "franchise\/settings",
        "name": "franchise.setting.index"
    },
    {
        "uri": "franchise\/settings\/target\/{outlet_id}",
        "name": "franchise.setting.outlet.getOutletTarget"
    },
    {
        "uri": "franchise\/settings\/target\/{outlet_id}",
        "name": "franchise.setting.outlet.saveOutletTarget"
    },
    {
        "uri": "franchise\/region",
        "name": "franchise.region.index"
    },
    {
        "uri": "franchise\/region\/{id}",
        "name": "franchise.region.show"
    },
    {
        "uri": "franchise\/region",
        "name": "franchise.region.store"
    },
    {
        "uri": "franchise\/region",
        "name": "franchise.region.delete"
    },
    {
        "uri": "franchise\/region\/{id}",
        "name": "franchise.region.update"
    },
    {
        "uri": "franchise\/tax",
        "name": "franchise.inventory.tax.index"
    },
    {
        "uri": "franchise\/tax\/{id}",
        "name": "franchise.inventory.tax.show"
    },
    {
        "uri": "franchise\/tax\/export\/{type}",
        "name": "franchise.inventory.tax.exportAsFile"
    },
    {
        "uri": "franchise\/tax",
        "name": "franchise.inventory.tax.store"
    },
    {
        "uri": "franchise\/tax",
        "name": "franchise.inventory.tax.delete"
    },
    {
        "uri": "franchise\/tax\/{id}",
        "name": "franchise.inventory.tax.update"
    },
    {
        "uri": "franchise\/promotion",
        "name": "franchise.promotion.index"
    },
    {
        "uri": "franchise\/promotion\/{id}",
        "name": "franchise.promotion.show"
    },
    {
        "uri": "franchise\/promotion\/outlets",
        "name": "franchise.promotion.outlets"
    },
    {
        "uri": "franchise\/promotion\/export\/{type}",
        "name": "franchise.promotion.export"
    },
    {
        "uri": "franchise\/promotion",
        "name": "franchise.promotion.store"
    },
    {
        "uri": "franchise\/promotion\/{id}",
        "name": "franchise.promotion.update"
    },
    {
        "uri": "franchise\/promotion\/create",
        "name": "franchise.promotion.create"
    },
    {
        "uri": "franchise\/promotion",
        "name": "franchise.promotion.delete"
    },
    {
        "uri": "franchise\/promotion\/stations_count",
        "name": "franchise.promotion.stations_count"
    },
    {
        "uri": "franchise\/promotion\/stations",
        "name": "franchise.promotion.stations"
    },
    {
        "uri": "franchise\/attendant-tagging",
        "name": "franchise.attendant.tagging.index"
    },
    {
        "uri": "franchise\/attendant-tagging\/list\/{outletId}",
        "name": "franchise.attendant.tagging.list"
    },
    {
        "uri": "franchise\/attendant-tagging\/outlet\/list",
        "name": "franchise.attendant.tagging.outlet.list"
    },
    {
        "uri": "franchise\/attendant-tagging\/show\/{outletId}",
        "name": "franchise.attendant.tagging.show"
    },
    {
        "uri": "franchise\/attendant-tagging\/save",
        "name": "franchise.attendant.tagging.save"
    },
    {
        "uri": "franchise\/attendant-tagging\/card\/save",
        "name": "franchise.attendant.tagging.card.save"
    },
    {
        "uri": "franchise\/attendant-tagging\/card\/delete",
        "name": "franchise.attendant.tagging.card.delete"
    },
    {
        "uri": "franchise\/attendant-tagging\/save\/outlet-safe-drop",
        "name": "franchise.attendant.tagging.save.outlet.safe.drop"
    },
    {
        "uri": "franchise\/user\/role",
        "name": "franchise.role.index"
    },
    {
        "uri": "franchise\/user\/role",
        "name": "franchise.role.store"
    },
    {
        "uri": "franchise\/user\/role\/{id}",
        "name": "franchise.role.update"
    },
    {
        "uri": "franchise\/user\/role\/delete",
        "name": "franchise.role.delete"
    },
    {
        "uri": "franchise\/logo",
        "name": "franchise.logo.index"
    },
    {
        "uri": "franchise\/logo\/media",
        "name": "franchise.logo.media"
    },
    {
        "uri": "franchise\/logo\/favicon",
        "name": "franchise.logo.favicon.media"
    },
    {
        "uri": "franchise\/order-layout",
        "name": "franchise.order_layout.index"
    },
    {
        "uri": "franchise\/order-layout\/{id}",
        "name": "franchise.order_layout.show"
    },
    {
        "uri": "franchise\/order-layout\/group",
        "name": "franchise.order_layout.group.index"
    },
    {
        "uri": "franchise\/order-layout",
        "name": "franchise.order_layout.create"
    },
    {
        "uri": "franchise\/order-layout\/{id}",
        "name": "franchise.order_layout.update"
    },
    {
        "uri": "franchise\/order-layout\/{id}",
        "name": "franchise.order_layout.clone"
    },
    {
        "uri": "franchise\/order-layout",
        "name": "franchise.order_layout.delete"
    },
    {
        "uri": "franchise\/order-layout\/page\/media",
        "name": "franchise.order_layout.page.media"
    },
    {
        "uri": "franchise\/order-layout\/group",
        "name": "franchise.order_layout.group.create"
    },
    {
        "uri": "franchise\/order-layout\/group\/{id}",
        "name": "franchise.order_layout.group.update"
    },
    {
        "uri": "franchise\/order-layout\/group\/{id}",
        "name": "franchise.order_layout.group.delete"
    },
    {
        "uri": "franchise\/presetreason",
        "name": "franchise.setting.presetreason.index"
    },
    {
        "uri": "franchise\/presetreason\/{id}",
        "name": "franchise.setting.presetreason.show"
    },
    {
        "uri": "franchise\/presetreason\/export\/{type}",
        "name": "franchise.setting.presetreason.exportAsFile"
    },
    {
        "uri": "franchise\/presetreason",
        "name": "franchise.setting.presetreason.store"
    },
    {
        "uri": "franchise\/presetreason\/{id}",
        "name": "franchise.setting.presetreason.update"
    },
    {
        "uri": "franchise\/presetreason",
        "name": "franchise.setting.presetreason.delete"
    },
    {
        "uri": "franchise\/label",
        "name": "franchise.label.index"
    },
    {
        "uri": "franchise\/label\/{id}",
        "name": "franchise.label.show"
    },
    {
        "uri": "franchise\/label",
        "name": "franchise.label.store"
    },
    {
        "uri": "franchise\/label",
        "name": "franchise.label.delete"
    },
    {
        "uri": "franchise\/label\/{id}",
        "name": "franchise.label.update"
    },
    {
        "uri": "franchise\/shelf\/label\/print",
        "name": "franchise.shelf.label.print"
    },
    {
        "uri": "franchise\/shelf\/label\/send\/email",
        "name": "franchise.shelf.label.send.email"
    },
    {
        "uri": "franchise\/shelf\/label\/operators",
        "name": "franchise.shelf.label.operators"
    },
    {
        "uri": "franchise\/shelf\/label\/{id}\/retailers",
        "name": "franchise.shelf.label.retailers"
    },
    {
        "uri": "franchise\/staff",
        "name": "franchise.staff.index"
    },
    {
        "uri": "franchise\/staff\/{id}",
        "name": "franchise.staff.show"
    },
    {
        "uri": "franchise\/staff\/{id}\/attendance",
        "name": "franchise.staff.attendance"
    },
    {
        "uri": "franchise\/staff\/roles",
        "name": "franchise.staff.getRolesAndPermissions"
    },
    {
        "uri": "franchise\/staff\/permission\/list",
        "name": "franchise.staff.permissionList"
    },
    {
        "uri": "franchise\/staff\/restore\/list",
        "name": "franchise.staff.restoreStaffList"
    },
    {
        "uri": "franchise\/staff",
        "name": "franchise.staff.store"
    },
    {
        "uri": "franchise\/staff\/restore",
        "name": "franchise.staff.restoreStaffsAction"
    },
    {
        "uri": "franchise\/staff\/addMedia",
        "name": "franchise.staff.addMedia"
    },
    {
        "uri": "franchise\/staff\/{id}",
        "name": "franchise.staff.update"
    },
    {
        "uri": "franchise\/staff\/update",
        "name": "franchise.staff.bulkUpdate"
    },
    {
        "uri": "franchise\/staff\/{id}",
        "name": "franchise.staff.delete"
    },
    {
        "uri": "franchise\/staff\/delete",
        "name": "franchise.staff.bulkDelete"
    },
    {
        "uri": "franchise\/fuel",
        "name": "franchise.inventory.fuel.index"
    },
    {
        "uri": "franchise\/fuel\/fuels",
        "name": "franchise.inventory.fuel.fuels"
    },
    {
        "uri": "franchise\/fuel\/fuelset",
        "name": "franchise.inventory.fuel.fuelset.index"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/v2",
        "name": "franchise.inventory.fuel.fuelset.index.v2"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/latest",
        "name": "franchise.inventory.fuel.fuelset.latest"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/outlet\/{id}",
        "name": "franchise.inventory.fuel.fuelset.outlet.acknowledgements"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/outlet\/total\/{id}",
        "name": "franchise.inventory.fuel.fuelset.outlet.acknowledgements.total"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/meta",
        "name": "franchise.inventory.fuel.fuelset.meta"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/state-fuel-price",
        "name": "franchise.inventory.fuel.fuelset.state-fuel-price"
    },
    {
        "uri": "franchise\/fuel\/site-acknowledgement",
        "name": "franchise.inventory.fuel.site-acknowledgement.index"
    },
    {
        "uri": "franchise\/fuel\/site-acknowledgement\/list",
        "name": "franchise.inventory.fuel.site-acknowledgement.list"
    },
    {
        "uri": "franchise\/fuel\/site-acknowledgement\/meta",
        "name": "franchise.inventory.fuel.site-acknowledgement.meta"
    },
    {
        "uri": "franchise\/fuel\/site-acknowledgement\/status",
        "name": "franchise.inventory.fuel.site-acknowledgement.status"
    },
    {
        "uri": "franchise\/fuel\/site-acknowledgement\/export\/{type}",
        "name": "franchise.inventory.fuel.site-acknowledgement.export"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/create",
        "name": "franchise.inventory.fuel.fuelset.create"
    },
    {
        "uri": "franchise\/fuel\/fuelset",
        "name": "franchise.inventory.fuel.fuelset.store"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/stations-count",
        "name": "franchise.inventory.fuel.fuelset.stations-count"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/stations",
        "name": "franchise.inventory.fuel.fuelset.stations"
    },
    {
        "uri": "franchise\/fuel\/fuelset\/station-datatable",
        "name": "franchise.inventory.fuel.fuelset.station-datatable"
    },
    {
        "uri": "franchise\/fuel\/dipping",
        "name": "franchise.inventory.fuel.dipping.index"
    },
    {
        "uri": "franchise\/fuel\/api\/dipping",
        "name": "franchise.inventory.fuel.dipping.list"
    },
    {
        "uri": "franchise\/fuel\/api\/audit\/dipping\/{id}",
        "name": "franchise.inventory.fuel.dipping.audit"
    },
    {
        "uri": "franchise\/fuel\/dipping\/export\/{type}",
        "name": "franchise.inventory.fuel.dipping.export"
    },
    {
        "uri": "franchise\/fuel\/dipping\/export-details\/{type}",
        "name": "franchise.inventory.fuel.dipping.export-details"
    },
    {
        "uri": "franchise\/fuel\/dipping",
        "name": "franchise.inventory.fuel.dipping.create"
    },
    {
        "uri": "franchise\/fuel\/dipping",
        "name": "franchise.inventory.fuel.dipping.delete"
    },
    {
        "uri": "franchise\/fuel\/dipping\/{id}",
        "name": "franchise.inventory.fuel.dipping.update"
    },
    {
        "uri": "franchise\/fuel\/dipping\/movement",
        "name": "franchise.inventory.fuel.dipping.create-movement"
    },
    {
        "uri": "franchise\/fuel\/dipping\/movement\/{id}",
        "name": "franchise.inventory.fuel.dipping.update-movement"
    },
    {
        "uri": "franchise\/fuel\/dipping\/movement\/{id}\/commit",
        "name": "franchise.inventory.fuel.dipping.commit-movement"
    },
    {
        "uri": "franchise\/fuel\/dipping\/movements",
        "name": "franchise.inventory.fuel.dipping.delete-movements"
    },
    {
        "uri": "franchise\/fuel\/receiving",
        "name": "franchise.inventory.fuel.receiving.index"
    },
    {
        "uri": "franchise\/fuel\/api\/receiving",
        "name": "franchise.inventory.fuel.receiving.list"
    },
    {
        "uri": "franchise\/fuel\/api\/audit\/receiving\/{id}",
        "name": "franchise.inventory.fuel.receiving.audit"
    },
    {
        "uri": "franchise\/fuel\/receiving\/export\/{type}",
        "name": "franchise.inventory.fuel.receiving.export"
    },
    {
        "uri": "franchise\/fuel\/receiving\/export-details\/{type}",
        "name": "franchise.inventory.fuel.receiving.export-details"
    },
    {
        "uri": "franchise\/fuel\/receiving",
        "name": "franchise.inventory.fuel.receiving.create"
    },
    {
        "uri": "franchise\/fuel\/receiving",
        "name": "franchise.inventory.fuel.receiving.delete"
    },
    {
        "uri": "franchise\/fuel\/receiving\/{id}",
        "name": "franchise.inventory.fuel.receiving.update"
    },
    {
        "uri": "franchise\/fuel\/receiving\/movement",
        "name": "franchise.inventory.fuel.receiving.create-movement"
    },
    {
        "uri": "franchise\/fuel\/receiving\/movement\/{id}",
        "name": "franchise.inventory.fuel.receiving.update-movement"
    },
    {
        "uri": "franchise\/fuel\/receiving\/movement\/{id}\/commit",
        "name": "franchise.inventory.fuel.receiving.commit-movement"
    },
    {
        "uri": "franchise\/fuel\/receiving\/movements",
        "name": "franchise.inventory.fuel.receiving.delete-movements"
    },
    {
        "uri": "franchise\/fuel\/receiving\/sales-within",
        "name": "franchise.inventory.fuel.receiving.sales-within"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation",
        "name": "franchise.inventory.fuel.daily-reconciliation.index"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/list",
        "name": "franchise.inventory.fuel.daily-reconciliation.list"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/export-dashboard",
        "name": "franchise.inventory.fuel.daily-reconciliation.export_dashboard"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/{id}",
        "name": "franchise.inventory.fuel.daily-reconciliation.show"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/report\/{id}",
        "name": "franchise.inventory.fuel.daily-reconciliation.report"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/report\/history\/{id}",
        "name": "franchise.inventory.fuel.daily-reconciliation.report.history"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/report\/turnover",
        "name": "franchise.inventory.fuel.daily-reconciliation.report.turnover"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/report\/stock",
        "name": "franchise.inventory.fuel.daily-reconciliation.report.stock"
    },
    {
        "uri": "franchise\/fuel\/daily-reconciliation\/report\/submit",
        "name": "franchise.inventory.fuel.daily-reconciliation.report.submit"
    },
    {
        "uri": "franchise\/uom",
        "name": "franchise.uom.list"
    },
    {
        "uri": "franchise\/topup\/{id}\/list\/{account_id}",
        "name": "franchise.topup.index"
    },
    {
        "uri": "franchise\/topup\/{id}\/show\/{account_id}\/topup\/{transaction_id}",
        "name": "franchise.topup.show"
    },
    {
        "uri": "franchise\/topup\/{id}\/statement\/{account_id}",
        "name": "franchise.topup.statement"
    },
    {
        "uri": "franchise\/topup\/{id}\/invoice\/{account_id}",
        "name": "franchise.topup.invoice"
    },
    {
        "uri": "franchise\/topup",
        "name": "franchise.topup.store"
    },
    {
        "uri": "franchise\/topup\/{client_id}\/export\/{user_id}\/{type}",
        "name": "franchise.topup.export"
    },
    {
        "uri": "franchise\/topup\/{client_id}\/transactionexport\/{user_id}\/{type}",
        "name": "franchise.topup.transactionexport"
    },
    {
        "uri": "franchise\/topup\/{outletId}\/void\/{id}",
        "name": "franchise.topup.voidtopup"
    },
    {
        "uri": "franchise\/restriction",
        "name": "franchise.restriction.index"
    },
    {
        "uri": "franchise\/restriction\/create",
        "name": "franchise.restriction.create"
    },
    {
        "uri": "franchise\/restriction\/search\/restriction\/meta",
        "name": "franchise.restriction.search.meta"
    },
    {
        "uri": "franchise\/restriction\/outlets",
        "name": "franchise.restriction.outlets"
    },
    {
        "uri": "franchise\/restriction\/stations",
        "name": "franchise.restriction.stations"
    },
    {
        "uri": "franchise\/restriction\/stations\/count",
        "name": "franchise.restriction.stations_count"
    },
    {
        "uri": "franchise\/restriction\/sub_category",
        "name": "franchise.restriction.sub-category"
    },
    {
        "uri": "franchise\/restriction\/{id}",
        "name": "franchise.restriction.show"
    },
    {
        "uri": "franchise\/restriction\/{id}\/edit",
        "name": "franchise.restriction.edit"
    },
    {
        "uri": "franchise\/restriction\/{id}",
        "name": "franchise.restriction.update"
    },
    {
        "uri": "franchise\/restriction",
        "name": "franchise.restriction.delete"
    },
    {
        "uri": "franchise\/restriction",
        "name": "franchise.restriction.store"
    },
    {
        "uri": "franchise\/user",
        "name": "franchise.user.index"
    },
    {
        "uri": "franchise\/user\/outlets",
        "name": "franchise.user.outlets"
    },
    {
        "uri": "franchise\/user",
        "name": "franchise.user.store"
    },
    {
        "uri": "franchise\/user\/{id}\/media",
        "name": "franchise.user.storemedia"
    },
    {
        "uri": "franchise\/user\/stations_count",
        "name": "franchise.user.stations_count"
    },
    {
        "uri": "franchise\/user\/stations",
        "name": "franchise.user.stations"
    },
    {
        "uri": "franchise\/user\/{id}",
        "name": "franchise.user.update"
    },
    {
        "uri": "franchise\/user\/update",
        "name": "franchise.user.bulkupdate"
    },
    {
        "uri": "franchise\/user\/delete",
        "name": "franchise.user.delete"
    },
    {
        "uri": "franchise\/profile",
        "name": "franchise.profile.index"
    },
    {
        "uri": "franchise\/profile",
        "name": "franchise.profile.update"
    },
    {
        "uri": "franchise\/profile\/media",
        "name": "franchise.profile.media"
    },
    {
        "uri": "franchise\/profile\/password",
        "name": "franchise.profile.password.update"
    },
    {
        "uri": "franchise\/outlet",
        "name": "franchise.outlet.index"
    },
    {
        "uri": "franchise\/outlet\/{id}",
        "name": "franchise.outlet.show"
    },
    {
        "uri": "franchise\/outlet",
        "name": "franchise.outlet.store"
    },
    {
        "uri": "franchise\/outlet\/addmedia",
        "name": "franchise.outlet.addmedia"
    },
    {
        "uri": "franchise\/outlet\/{id}",
        "name": "franchise.outlet.update"
    },
    {
        "uri": "franchise\/outlet\/{id}",
        "name": "franchise.outlet.delete"
    },
    {
        "uri": "franchise\/outlet\/preference\/{outlet_id}",
        "name": "franchise.outlet.savePreference"
    },
    {
        "uri": "franchise\/outlet\/assign-labels",
        "name": "franchise.outlet.assign-labels"
    },
    {
        "uri": "franchise\/outlet\/tax\/{id}\/datatable",
        "name": "franchise.outlet.tax.getOutletTaxesDatatable"
    },
    {
        "uri": "franchise\/outlet\/tax\/{id}",
        "name": "franchise.outlet.tax.getOutletTaxes"
    },
    {
        "uri": "franchise\/outlet\/tax\/{outlet_id}\/{tax_id}",
        "name": "franchise.outlet.tax.getOutletTax"
    },
    {
        "uri": "franchise\/outlet\/tax\/assign\/{outlet_id}",
        "name": "franchise.outlet.tax.assignOutletTax"
    },
    {
        "uri": "franchise\/outlet\/tax\/update\/{outlet_id}",
        "name": "franchise.outlet.tax.updateOutletTax"
    },
    {
        "uri": "franchise\/outlet\/tax\/remove\/{outlet_id}",
        "name": "franchise.outlet.tax.removeOutletTaxes"
    },
    {
        "uri": "franchise\/outlet\/drawerSession\/{outlet_id}",
        "name": "franchise.outlet.drawerSession.getDrawerSessionList"
    },
    {
        "uri": "franchise\/outlet\/{outlet_id}\/staff\/staffsales",
        "name": "franchise.outlet.staff.staffsales"
    },
    {
        "uri": "franchise\/outlet\/{outlet_id}\/staff\/export\/{type}",
        "name": "franchise.outlet.staff.exportstaffsales"
    },
    {
        "uri": "franchise\/outlet\/{outlet_id}\/staff\/getTodaySalesAndPaxByOutletStaff",
        "name": "franchise.outlet.staff.todaySalesAndPax"
    },
    {
        "uri": "franchise\/settings\/central-settings",
        "name": "franchise.setting.central_settings.set.index"
    },
    {
        "uri": "franchise\/settings\/central-settings\/{id}",
        "name": "franchise.setting.central_settings.set.show"
    },
    {
        "uri": "franchise\/settings\/central-settings\/assigned-outlets",
        "name": "franchise.setting.central_settings.set.assigned_outlets"
    },
    {
        "uri": "franchise\/settings\/central-settings",
        "name": "franchise.setting.central_settings.set.create"
    },
    {
        "uri": "franchise\/settings\/central-settings\/{id}",
        "name": "franchise.setting.central_settings.set.update"
    },
    {
        "uri": "franchise\/settings\/central-settings",
        "name": "franchise.setting.central_settings.set.delete"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/products",
        "name": "franchise.inventory.pricebook.products"
    },
    {
        "uri": "franchise\/pricebook\/edit\/{id}",
        "name": "franchise.inventory.pricebook.edit"
    },
    {
        "uri": "franchise\/pricebook\/search\/pricebook\/meta",
        "name": "franchise.inventory.pricebook.search.meta"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/outlets",
        "name": "franchise.inventory.pricebook.outlets"
    },
    {
        "uri": "franchise\/pricebook\/export\/{type}",
        "name": "franchise.inventory.pricebook.exportPricebook"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/products\/export\/{type}",
        "name": "franchise.inventory.pricebook.products.export"
    },
    {
        "uri": "franchise\/pricebook\/{id}",
        "name": "franchise.inventory.pricebook.update"
    },
    {
        "uri": "franchise\/pricebook",
        "name": "franchise.inventory.pricebook.delete"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/products_pool",
        "name": "franchise.inventory.pricebook.products_pool"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/products_count",
        "name": "franchise.inventory.pricebook.products_count"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/batch_add",
        "name": "franchise.inventory.pricebook.batch_add"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/batch_update",
        "name": "franchise.inventory.pricebook.batch_update"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/export\/{type}\/pricebook\/{pricebook}",
        "name": "franchise.inventory.pricebook.exportAsFile"
    },
    {
        "uri": "franchise\/pricebook\/import",
        "name": "franchise.inventory.pricebook.import"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/validate\/{importKey}",
        "name": "franchise.inventory.pricebook.validate_data"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/store\/{importKey}",
        "name": "franchise.inventory.pricebook.store_data"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/read-data\/{importKey}",
        "name": "franchise.inventory.pricebook.readdata"
    },
    {
        "uri": "franchise\/pricebook\/existing\/{id}",
        "name": "franchise.inventory.pricebook.existing.save"
    },
    {
        "uri": "franchise\/pricebook\/import-status\/{importKey}",
        "name": "franchise.inventory.pricebook.import_status"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/stations",
        "name": "franchise.inventory.pricebook.stations"
    },
    {
        "uri": "franchise\/pricebook\/{id}\/stations_count",
        "name": "franchise.inventory.pricebook.stations_count"
    },
    {
        "uri": "franchise\/pricebook\/product-variant-entry\/{id}",
        "name": "franchise.inventory.pricebook.entry.save"
    },
    {
        "uri": "franchise\/pricebook\/product-variant-entry\/{id}\/delete",
        "name": "franchise.inventory.pricebook.entry.delete"
    },
    {
        "uri": "franchise\/override_pricebook",
        "name": "franchise.inventory.override_pricebook.index"
    },
    {
        "uri": "franchise\/override_pricebook\/edit\/{id}",
        "name": "franchise.inventory.override_pricebook.edit"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}",
        "name": "franchise.inventory.override_pricebook.show"
    },
    {
        "uri": "franchise\/override_pricebook\/search\/override-pricebook\/meta",
        "name": "franchise.inventory.override_pricebook.search.meta"
    },
    {
        "uri": "franchise\/override_pricebook\/search\/override\/meta",
        "name": "franchise.inventory.override_pricebook.search.meta.override"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/entries",
        "name": "franchise.inventory.override_pricebook.entries"
    },
    {
        "uri": "franchise\/override_pricebook\/average\/cost",
        "name": "franchise.inventory.override_pricebook.average.cost"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/products_pool",
        "name": "franchise.inventory.override_pricebook.products_pool"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/products_count",
        "name": "franchise.inventory.override_pricebook.products_count"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/batch_add",
        "name": "franchise.inventory.override_pricebook.batch_add"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/batch_update",
        "name": "franchise.inventory.override_pricebook.batch_update"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/entries",
        "name": "franchise.inventory.override_pricebook.entries.save"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/delete_entries",
        "name": "franchise.inventory.override_pricebook.entries.delete"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/export\/{type}",
        "name": "franchise.inventory.override_pricebook.exportAsFile"
    },
    {
        "uri": "franchise\/override_pricebook\/import",
        "name": "franchise.inventory.override_pricebook.import"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/validate\/{importKey}",
        "name": "franchise.inventory.override_pricebook.validate_data"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}\/store\/{importKey}",
        "name": "franchise.inventory.override_pricebook.store_data"
    },
    {
        "uri": "franchise\/override_pricebook\/read-data\/{importKey}",
        "name": "franchise.inventory.override_pricebook.readdata"
    },
    {
        "uri": "franchise\/override_pricebook\/existing\/{id}",
        "name": "franchise.inventory.override_pricebook.existing.save"
    },
    {
        "uri": "franchise\/override_pricebook\/import-status\/{importKey}",
        "name": "franchise.inventory.override_pricebook.import_status"
    },
    {
        "uri": "franchise\/override_pricebook\/edit\/{id}\/ial",
        "name": "franchise.inventory.override_pricebook.ial.index"
    },
    {
        "uri": "franchise\/override_pricebook\/edit\/{id}\/ial",
        "name": "franchise.inventory.override_pricebook.ial.import"
    },
    {
        "uri": "franchise\/override_pricebook\/ial\/{id}\/{key}",
        "name": "franchise.inventory.override_pricebook.ial.download"
    },
    {
        "uri": "franchise\/override_pricebook\/{id}",
        "name": "franchise.inventory.override_pricebook.update"
    },
    {
        "uri": "franchise\/override_pricebook\/override",
        "name": "franchise.inventory.override_pricebook.override.delete"
    },
    {
        "uri": "franchise\/override_pricebook",
        "name": "franchise.inventory.override_pricebook.store"
    },
    {
        "uri": "franchise\/report\/non-fuel\/loyalty-category",
        "name": "franchise.report.non_fuel.loyalty_category.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/loyalty-category\/category-sales",
        "name": "franchise.report.non_fuel.loyalty_category.getCategorySales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/loyalty-category\/search\/meta",
        "name": "franchise.report.non_fuel.loyalty_category.search.meta"
    },
    {
        "uri": "franchise\/report\/non-fuel\/loyalty-category\/export\/{type}",
        "name": "franchise.report.non_fuel.loyalty_category.export"
    },
    {
        "uri": "franchise\/report\/drawer-session",
        "name": "franchise.report.drawersession.index"
    },
    {
        "uri": "franchise\/report\/drawer-session\/{id}",
        "name": "franchise.report.drawersession.show"
    },
    {
        "uri": "franchise\/report\/drawer-session\/fuel\/{id}",
        "name": "franchise.report.drawersession.showfuel"
    },
    {
        "uri": "franchise\/report\/drawer-session\/shell-fuel\/{id}",
        "name": "franchise.report.drawersession.showshellfuel"
    },
    {
        "uri": "franchise\/report\/drawer-session\/bhp-fuel\/{id}",
        "name": "franchise.report.drawersession.showbhpfuel"
    },
    {
        "uri": "franchise\/report\/drawer-session\/export\/{type}",
        "name": "franchise.report.drawersession.exportAsFile"
    },
    {
        "uri": "franchise\/report\/drawer-session\/drawersession\/export\/{id}",
        "name": "franchise.report.drawersession.exportDrawerAsFile"
    },
    {
        "uri": "franchise\/report\/drawer-session\/list",
        "name": "franchise.report.drawersession.drawerSessionList"
    },
    {
        "uri": "franchise\/report\/drawer-session\/fuel\/list",
        "name": "franchise.report.drawersession.fuelDrawerSessionList"
    },
    {
        "uri": "franchise\/report\/drawer-session\/dropdown",
        "name": "franchise.report.drawersession.drawerSessionDropdown"
    },
    {
        "uri": "franchise\/report\/drawer-session\/correction\/{id}",
        "name": "franchise.report.drawersession.correction"
    },
    {
        "uri": "franchise\/report\/ronpos-reimbursement",
        "name": "franchise.report.shell_reimbursement.index"
    },
    {
        "uri": "franchise\/report\/ronpos-reimbursement\/list",
        "name": "franchise.report.shell_reimbursement.list"
    },
    {
        "uri": "franchise\/report\/ronpos-reimbursement\/export\/{type}\/{detail}",
        "name": "franchise.report.shell_reimbursement.export"
    },
    {
        "uri": "franchise\/report\/ronpos-reimbursement\/search\/meta",
        "name": "franchise.report.shell_reimbursement.search.meta"
    },
    {
        "uri": "franchise\/report\/ronpos-reimbursement\/terminal-list",
        "name": "franchise.report.shell_reimbursement.terminal-list"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/summary-list",
        "name": "franchise.report.cancelled_cart.summary_list"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/export\/{type}",
        "name": "franchise.report.cancelled_cart.export"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/details\/{order_id}",
        "name": "franchise.report.cancelled_cart.details"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/details\/postgres\/{cancelled_cart_number}",
        "name": "franchise.report.cancelled_cart.detailsPostgres"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/summary-stats",
        "name": "franchise.report.cancelled_cart.summary_stats"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/list",
        "name": "franchise.report.cancelled_cart.list"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/V2\/export\/{type}",
        "name": "franchise.report.cancelled_cart.v2.export"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/count",
        "name": "franchise.report.cancelled_cart.count"
    },
    {
        "uri": "franchise\/report\/cancelled-cart\/amount",
        "name": "franchise.report.cancelled_cart.amount"
    },
    {
        "uri": "franchise\/report\/transaction",
        "name": "franchise.report.transaction.index"
    },
    {
        "uri": "franchise\/report\/transaction",
        "name": "franchise.report.transaction.transaction"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/transaction-sum",
        "name": "franchise.report.transaction.getSumTransactionType"
    },
    {
        "uri": "franchise\/report\/transaction\/graph\/{type}",
        "name": "franchise.report.transaction.export_graph"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/graph-transaction\/{type?}",
        "name": "franchise.report.transaction.graphTransaction"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/receipt",
        "name": "franchise.report.transaction.getTransactionReceipt"
    },
    {
        "uri": "franchise\/report\/transaction\/{receiptNumber}\/receipt\/postgres",
        "name": "franchise.report.transaction.getTransactionReceiptPostgres"
    },
    {
        "uri": "franchise\/report\/transaction\/breakdown",
        "name": "franchise.report.transaction.breakdown"
    },
    {
        "uri": "franchise\/report\/transaction\/export-breakdown\/{type}",
        "name": "franchise.report.transaction.breakdown_export"
    },
    {
        "uri": "franchise\/report\/transaction\/breakdown-details",
        "name": "franchise.report.transaction.breakdown_details"
    },
    {
        "uri": "franchise\/report\/transaction\/export-breakdown-details\/{type}",
        "name": "franchise.report.transaction.breakdown_details_export"
    },
    {
        "uri": "franchise\/report\/transaction\/export\/{summary}\/{type}",
        "name": "franchise.report.transaction.exportAsFile"
    },
    {
        "uri": "franchise\/report\/transaction\/export-details\/{summary}\/{type}",
        "name": "franchise.report.transaction.exportDetailsAsFile"
    },
    {
        "uri": "franchise\/report\/transaction\/{id}\/export\/{refund_id}\/{voided}",
        "name": "franchise.report.transaction.exportReceipt"
    },
    {
        "uri": "franchise\/report\/transaction\/export-receipt-postgres",
        "name": "franchise.report.transaction.exportReceiptPostgres"
    },
    {
        "uri": "franchise\/report\/transaction\/first\/{outletId}",
        "name": "franchise.report.transaction.first"
    },
    {
        "uri": "franchise\/report\/transaction\/search\/meta",
        "name": "franchise.report.transaction.meta"
    },
    {
        "uri": "franchise\/report\/transaction\/search\/meta\/V2",
        "name": "franchise.report.transaction.meta.V2"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/{id}\/transaction-sum",
        "name": "franchise.report.transaction.es.getSumTransactionType"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/{id}\/graph-transaction",
        "name": "franchise.report.transaction.es.graphTransaction"
    },
    {
        "uri": "franchise\/report\/transaction\/es",
        "name": "franchise.report.transaction.es.index"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/transaction-list",
        "name": "franchise.report.transaction.es.transactionList"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/breakdown",
        "name": "franchise.report.transaction.es.breakdown"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/breakdown-details",
        "name": "franchise.report.transaction.es.breakdown_details"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/graph\/{type}",
        "name": "franchise.report.transaction.es.export_graph"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/export\/{summary}\/{type}",
        "name": "franchise.report.transaction.es.exportAsFile"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/export-breakdown\/{type}",
        "name": "franchise.report.transaction.es.breakdown_export"
    },
    {
        "uri": "franchise\/report\/transaction\/es\/export-breakdown-details\/{type}",
        "name": "franchise.report.transaction.es.breakdown_details_export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/best-seller",
        "name": "franchise.report.non_fuel.best-seller.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/best-seller\/search\/meta",
        "name": "franchise.report.non_fuel.best-seller.search.meta"
    },
    {
        "uri": "franchise\/report\/non-fuel\/best-seller\/api\/list",
        "name": "franchise.report.non_fuel.best-seller.list"
    },
    {
        "uri": "franchise\/report\/non-fuel\/best-seller\/api\/summary",
        "name": "franchise.report.non_fuel.best-seller.summary"
    },
    {
        "uri": "franchise\/report\/non-fuel\/best-seller\/export\/{type}",
        "name": "franchise.report.non_fuel.best-seller.export"
    },
    {
        "uri": "franchise\/report\/tng\/rfid\/reimbursement",
        "name": "franchise.report.tng.rfid.reimbursement.index"
    },
    {
        "uri": "franchise\/report\/tng\/rfid\/reimbursement\/list",
        "name": "franchise.report.tng.rfid.reimbursement.list"
    },
    {
        "uri": "franchise\/report\/tng\/rfid\/reimbursement\/export\/{type}\/{detail}",
        "name": "franchise.report.tng.rfid.reimbursement.export"
    },
    {
        "uri": "franchise\/report\/hourly",
        "name": "franchise.report.hourly.index"
    },
    {
        "uri": "franchise\/report\/hourly",
        "name": "franchise.report.hourly.hourly"
    },
    {
        "uri": "franchise\/report\/hourly\/{id}\/graph\/{type}",
        "name": "franchise.report.hourly.exportGraphData"
    },
    {
        "uri": "franchise\/report\/hourly\/{id}\/summary",
        "name": "franchise.report.hourly.getHourlySummary"
    },
    {
        "uri": "franchise\/report\/hourly\/export\/{type}",
        "name": "franchise.report.hourly.exportAsFile"
    },
    {
        "uri": "franchise\/report\/hourly\/search\/meta",
        "name": "franchise.report.hourly.search.meta"
    },
    {
        "uri": "franchise\/report\/hourly\/search\/meta\/V2",
        "name": "franchise.report.hourly.search.meta.V2"
    },
    {
        "uri": "franchise\/report\/payment",
        "name": "franchise.report.payment.index"
    },
    {
        "uri": "franchise\/report\/payment\/method\/daily",
        "name": "franchise.report.payment.method.daily"
    },
    {
        "uri": "franchise\/report\/payment\/method\/daily\/export\/{type}",
        "name": "franchise.report.payment.method.daily.export"
    },
    {
        "uri": "franchise\/report\/payment\/method\/monthly\/export\/{type}",
        "name": "franchise.report.payment.method.monthly.export"
    },
    {
        "uri": "franchise\/report\/payment\/search\/meta",
        "name": "franchise.report.payment.search.meta"
    },
    {
        "uri": "franchise\/report\/payment\/search\/meta\/V2",
        "name": "franchise.report.payment.search.meta.V2"
    },
    {
        "uri": "franchise\/report\/bir-reports",
        "name": "franchise.report.bir_reports.index"
    },
    {
        "uri": "franchise\/report\/bir-reports\/generateSalesReport",
        "name": "franchise.report.bir_reports.generateSalesReport"
    },
    {
        "uri": "franchise\/report\/bir-reports\/generateSCReport",
        "name": "franchise.report.bir_reports.generateSCReport"
    },
    {
        "uri": "franchise\/report\/bir-reports\/generatePWDReport",
        "name": "franchise.report.bir_reports.generatePWDReport"
    },
    {
        "uri": "franchise\/report\/bir-reports\/generateNAACReport",
        "name": "franchise.report.bir_reports.generateNAACReport"
    },
    {
        "uri": "franchise\/report\/bir-reports\/generateSPReport",
        "name": "franchise.report.bir_reports.generateSPReport"
    },
    {
        "uri": "franchise\/report\/bir-reports\/export",
        "name": "franchise.report.bir_reports.exportAsFile"
    },
    {
        "uri": "franchise\/report\/basket",
        "name": "franchise.report.basket.index"
    },
    {
        "uri": "franchise\/report\/basket\/size\/daily",
        "name": "franchise.report.basket.size.daily"
    },
    {
        "uri": "franchise\/report\/basket\/size\/monthly",
        "name": "franchise.report.basket.size.monthly"
    },
    {
        "uri": "franchise\/report\/basket\/size\/daily\/export\/{type}",
        "name": "franchise.report.basket.size.daily.export"
    },
    {
        "uri": "franchise\/report\/basket\/size\/monthly\/export\/{type}",
        "name": "franchise.report.basket.size.monthly.export"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit",
        "name": "franchise.report.non_fuel.profit.index"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/search\/meta",
        "name": "franchise.report.non_fuel.profit.search.meta"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/list",
        "name": "franchise.report.non_fuel.profit.list"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/sub\/list",
        "name": "franchise.report.non_fuel.profit.sub.list"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/export\/{track}\/{type}",
        "name": "franchise.report.non_fuel.profit.export"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/summary",
        "name": "franchise.report.non_fuel.profit.summary"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/summaryV2",
        "name": "franchise.report.non_fuel.profit.summary.v2"
    },
    {
        "uri": "franchise\/report\/non_fuel\/profit\/report\/type",
        "name": "franchise.report.non_fuel.profit.report.type"
    },
    {
        "uri": "franchise\/report\/drawer-check",
        "name": "franchise.report.drawer-check.index"
    },
    {
        "uri": "franchise\/report\/drawer-check\/sync",
        "name": "franchise.report.drawer-check.sync"
    },
    {
        "uri": "franchise\/report\/drawer-check\/syncAt",
        "name": "franchise.report.drawer-check.syncAt"
    },
    {
        "uri": "franchise\/report\/cancelled-order",
        "name": "franchise.report.cancelled_order.index"
    },
    {
        "uri": "franchise\/report\/cancelled-order\/summary-list",
        "name": "franchise.report.cancelled_order.summary_list"
    },
    {
        "uri": "franchise\/report\/cancelled-order\/summary-stats",
        "name": "franchise.report.cancelled_order.summary_stats"
    },
    {
        "uri": "franchise\/report\/cancelled-order\/export\/{type}",
        "name": "franchise.report.cancelled_order.export"
    },
    {
        "uri": "franchise\/report\/till-closure",
        "name": "franchise.report.till_closure.index"
    },
    {
        "uri": "franchise\/report\/till-closure\/{id}",
        "name": "franchise.report.till_closure.get-till"
    },
    {
        "uri": "franchise\/report\/till-closure\/list\/{id}",
        "name": "franchise.report.till_closure.details"
    },
    {
        "uri": "franchise\/report\/till-closure\/fuel\/list",
        "name": "franchise.report.till_closure.fuelDrawerSessionList"
    },
    {
        "uri": "franchise\/report\/till-closure\/till-summary\/{id}",
        "name": "franchise.report.till_closure.show-tillsummary"
    },
    {
        "uri": "franchise\/report\/till-closure\/shell-till-summary\/{id}",
        "name": "franchise.report.till_closure.show-shell-tillsummary"
    },
    {
        "uri": "franchise\/report\/till-closure\/bhp-till-summary\/{id}",
        "name": "franchise.report.till_closure.show-bhp-tillsummary"
    },
    {
        "uri": "franchise\/report\/till-closure\/till-list\/{id}",
        "name": "franchise.report.till_closure.till-list"
    },
    {
        "uri": "franchise\/report\/till-closure\/day-operation\/{id}",
        "name": "franchise.report.till_closure.day-operation"
    },
    {
        "uri": "franchise\/report\/till-closure\/till-id\/{id}",
        "name": "franchise.report.till_closure.till-id"
    },
    {
        "uri": "franchise\/report\/till-closure\/summary\/{id}\/{status}",
        "name": "franchise.report.till_closure.summary"
    },
    {
        "uri": "franchise\/report\/till-closure\/all\/{id}\/{status}",
        "name": "franchise.report.till_closure.all"
    },
    {
        "uri": "franchise\/report\/till-closure\/till-summary-export\/{id}",
        "name": "franchise.report.till_closure.exportTillSummaryAsFile"
    },
    {
        "uri": "franchise\/report\/till-closure\/export\/{type}\/till",
        "name": "franchise.report.till_closure.exportAsFile"
    },
    {
        "uri": "franchise\/report\/till-closure\/export\/{type}\/cash-flow\/{id}\/{status}",
        "name": "franchise.report.till_closure.export"
    },
    {
        "uri": "franchise\/report\/till-closure\/card\/{id}",
        "name": "franchise.report.till_closure.show-card"
    },
    {
        "uri": "franchise\/report\/till-closure\/card-edc\/{id}",
        "name": "franchise.report.till_closure.show-card-edc"
    },
    {
        "uri": "franchise\/report\/till-closure\/card\/show\/{id}",
        "name": "franchise.report.till_closure.showcardsale"
    },
    {
        "uri": "franchise\/report\/till-closure\/card-edc\/show\/{id}",
        "name": "franchise.report.till_closure.showcardedcsale"
    },
    {
        "uri": "franchise\/report\/till-closure\/card\/{id}\/export\/{type}",
        "name": "franchise.report.till_closure.exportCardAsFile"
    },
    {
        "uri": "franchise\/report\/till-closure\/card-edc\/{id}\/export\/{type}",
        "name": "franchise.report.till_closure.exportCardEdcAsFile"
    },
    {
        "uri": "franchise\/report\/till-closure\/search\/meta",
        "name": "franchise.report.till_closure.search.meta"
    },
    {
        "uri": "franchise\/report\/till-closure\/till-time-close\/{id}",
        "name": "franchise.report.till_closure.till-time-close"
    },
    {
        "uri": "franchise\/report\/modifier",
        "name": "franchise.report.modifier.index"
    },
    {
        "uri": "franchise\/report\/modifier\/export\/{type}",
        "name": "franchise.report.modifier.exportAsFile"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix",
        "name": "franchise.report.non_fuel.sales_mix.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/api\/list",
        "name": "franchise.report.non_fuel.sales_mix.list"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/api\/test",
        "name": "franchise.report.non_fuel.sales_mix.test"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/search\/meta",
        "name": "franchise.report.non_fuel.sales_mix.search.meta"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/export\/{type}",
        "name": "franchise.report.non_fuel.sales_mix.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/exportDetails\/{type}",
        "name": "franchise.report.non_fuel.sales_mix.export-details"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/exportDetails\/v2\/{type}",
        "name": "franchise.report.non_fuel.sales_mix.export-details.v2"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-mix\/summary",
        "name": "franchise.report.non_fuel.sales_mix.summary"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category",
        "name": "franchise.report.non_fuel.sales_category.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/search\/meta",
        "name": "franchise.report.non_fuel.sales_category.search.meta"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/category-sales",
        "name": "franchise.report.non_fuel.sales_category.getCategorySales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/sub-category-sales",
        "name": "franchise.report.non_fuel.sales_category.subCategorySales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/export\/{type}",
        "name": "franchise.report.non_fuel.sales_category.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/export\/V2\/{type}",
        "name": "franchise.report.non_fuel.sales_category.export.V2"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/summary",
        "name": "franchise.report.non_fuel.sales_category.summary"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/es",
        "name": "franchise.report.non_fuel.sales_category.es.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/es\/summary",
        "name": "franchise.report.non_fuel.sales_category.es.summary"
    },
    {
        "uri": "franchise\/report\/non-fuel\/sales-category\/es\/export\/{type}",
        "name": "franchise.report.non_fuel.sales_category.es.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product",
        "name": "franchise.report.non_fuel.item.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/{id}\/summary",
        "name": "franchise.report.non_fuel.item.getChartSummary"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/export\/{type}",
        "name": "franchise.report.non_fuel.item.exportChartAsFile"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/tag-sales",
        "name": "franchise.report.non_fuel.item.getTagSales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/tag-sales-export\/{type}",
        "name": "franchise.report.non_fuel.item.exportTagSalesAsFile"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/category-sales",
        "name": "franchise.report.non_fuel.item.category_sales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/export-category-sales\/{type}",
        "name": "franchise.report.non_fuel.item.export_category_sales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/variant",
        "name": "franchise.report.non_fuel.item.variant.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/variant\/export\/{type}",
        "name": "franchise.report.non_fuel.item.variant.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/staff",
        "name": "franchise.report.non_fuel.item.staff.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/product\/staff\/export\/{type}",
        "name": "franchise.report.non_fuel.item.staff.export"
    },
    {
        "uri": "franchise\/report\/tax",
        "name": "franchise.report.tax.index"
    },
    {
        "uri": "franchise\/report\/tax\/export\/{type}",
        "name": "franchise.report.tax.exportAsFile"
    },
    {
        "uri": "franchise\/report\/tax\/tax-report",
        "name": "franchise.report.tax.getTaxReportList"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion",
        "name": "franchise.report.non_fuel.promotion.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion\/search\/meta",
        "name": "franchise.report.non_fuel.promotion.search.meta"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion\/summary",
        "name": "franchise.report.non_fuel.promotion.summary"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion\/sales",
        "name": "franchise.report.non_fuel.promotion.sales.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion\/sales\/detail",
        "name": "franchise.report.non_fuel.promotion.sales.detail"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion\/sales\/export",
        "name": "franchise.report.non_fuel.promotion.sales.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/promotion\/sales\/export-detail",
        "name": "franchise.report.non_fuel.promotion.sales.detail.export"
    },
    {
        "uri": "franchise\/report\/snapshot",
        "name": "franchise.report.snapshot.index"
    },
    {
        "uri": "franchise\/report\/snapshot\/{id}\/graph\/{type}",
        "name": "franchise.report.snapshot.exportGraphData"
    },
    {
        "uri": "franchise\/report\/snapshot\/{id}\/summary",
        "name": "franchise.report.snapshot.getSnapshotSummary"
    },
    {
        "uri": "franchise\/report\/snapshot\/export\/{type}",
        "name": "franchise.report.snapshot.exportAsFile"
    },
    {
        "uri": "franchise\/report\/snapshot\/export\/{type}",
        "name": "franchise.report.snapshot.exportAsFile"
    },
    {
        "uri": "franchise\/report\/snapshot\/product",
        "name": "franchise.report.snapshot.product"
    },
    {
        "uri": "franchise\/report\/snapshot\/product",
        "name": "franchise.report.snapshot.product"
    },
    {
        "uri": "franchise\/report\/attendant\/session",
        "name": "franchise.report.attendant.session.index"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/list",
        "name": "franchise.report.attendant.session.list"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/cashflow",
        "name": "franchise.report.attendant.session.cashflow"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/{id}",
        "name": "franchise.report.attendant.session.show"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/export\/{type}",
        "name": "franchise.report.attendant.session.export"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/cashflow\/export\/{type}",
        "name": "franchise.report.attendant.session.cashflow.export"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/print",
        "name": "franchise.report.attendant.session.print"
    },
    {
        "uri": "franchise\/report\/attendant\/session\/attendant\/staff",
        "name": "franchise.report.attendant.session.attendant.staff"
    },
    {
        "uri": "franchise\/report\/price-override",
        "name": "franchise.report.price-override.index"
    },
    {
        "uri": "franchise\/report\/price-override\/price-override",
        "name": "franchise.report.price-override.priceoverride"
    },
    {
        "uri": "franchise\/report\/price-override\/search\/meta",
        "name": "franchise.report.price-override.meta"
    },
    {
        "uri": "franchise\/report\/price-override\/overriden-staff",
        "name": "franchise.report.price-override.overriden.staff"
    },
    {
        "uri": "franchise\/report\/price-override\/cashier-staff",
        "name": "franchise.report.price-override.cashier.staff"
    },
    {
        "uri": "franchise\/report\/price-override\/export\/{type}",
        "name": "franchise.report.price-override.export"
    },
    {
        "uri": "franchise\/report\/till\/search\/meta",
        "name": "franchise.report.till.search.meta"
    },
    {
        "uri": "franchise\/report\/till\/till\/closure",
        "name": "franchise.report.till.closure"
    },
    {
        "uri": "franchise\/report\/till\/till\/summary",
        "name": "franchise.report.till.summary"
    },
    {
        "uri": "franchise\/report\/till\/till\/attendant",
        "name": "franchise.report.till.attendant"
    },
    {
        "uri": "franchise\/report\/till\/till\/attendant\/cashier",
        "name": "franchise.report.till.attendant.cashier"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/summary-list",
        "name": "franchise.report.cancelled_item.summary_list"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/summary-stats",
        "name": "franchise.report.cancelled_item.summary_stats"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/export\/{type}",
        "name": "franchise.report.cancelled_item.export"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/list",
        "name": "franchise.report.cancelled_item.list"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/v2\/export\/{type}",
        "name": "franchise.report.cancelled_item.v2.export"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/count",
        "name": "franchise.report.cancelled_item.count"
    },
    {
        "uri": "franchise\/report\/cancelled-item\/amount",
        "name": "franchise.report.cancelled_item.amount"
    },
    {
        "uri": "franchise\/report\/export-request\/list",
        "name": "franchise.report.exportRequest.list"
    },
    {
        "uri": "franchise\/report\/export-request\/{export_request_id}\/download",
        "name": "franchise.report.exportRequest.getDownloadableUrl"
    },
    {
        "uri": "franchise\/report\/daily-sales",
        "name": "franchise.report.daily_sales.index"
    },
    {
        "uri": "franchise\/report\/daily-sales\/{id}",
        "name": "franchise.report.daily_sales.show"
    },
    {
        "uri": "franchise\/report\/daily-sales\/card\/{id}",
        "name": "franchise.report.daily_sales.show-card"
    },
    {
        "uri": "franchise\/report\/daily-sales\/card-edc\/{id}",
        "name": "franchise.report.daily_sales.show-card-edc"
    },
    {
        "uri": "franchise\/report\/daily-sales\/show\/{id}",
        "name": "franchise.report.daily_sales.showdailysale"
    },
    {
        "uri": "franchise\/report\/daily-sales\/card\/show\/{id}",
        "name": "franchise.report.daily_sales.showcardsale"
    },
    {
        "uri": "franchise\/report\/daily-sales\/card-edc\/show\/{id}",
        "name": "franchise.report.daily_sales.showcardedcsale"
    },
    {
        "uri": "franchise\/report\/daily-sales\/export\/{type}",
        "name": "franchise.report.daily_sales.exportAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales\/card\/{id}\/export\/{type}",
        "name": "franchise.report.daily_sales.exportCardAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales\/card-edc\/{id}\/export\/{type}",
        "name": "franchise.report.daily_sales.exportCardEdcAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales\/dailysales\/export\/{id}\/{timezoneDevice}",
        "name": "franchise.report.daily_sales.exportDailyAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales\/list",
        "name": "franchise.report.daily_sales.dailySalesList"
    },
    {
        "uri": "franchise\/report\/daily-sales\/search\/meta",
        "name": "franchise.report.daily_sales.search.meta"
    },
    {
        "uri": "franchise\/report\/collected-sales\/{id}",
        "name": "franchise.report.lkh.show"
    },
    {
        "uri": "franchise\/report\/collected-sales\/{id}\/check",
        "name": "franchise.report.lkh.check-show"
    },
    {
        "uri": "franchise\/report\/collected-sales",
        "name": "franchise.report.lkh.store"
    },
    {
        "uri": "franchise\/report\/collected-sales\/collected\/export\/{id}",
        "name": "franchise.report.lkh.exportAsFile"
    },
    {
        "uri": "franchise\/report\/virtual_shift",
        "name": "franchise.report.virtual_shift.index"
    },
    {
        "uri": "franchise\/report\/virtual_shift\/sales",
        "name": "franchise.report.virtual_shift.sales"
    },
    {
        "uri": "franchise\/report\/virtual_shift\/export\/{type}",
        "name": "franchise.report.virtual_shift.export"
    },
    {
        "uri": "franchise\/report\/ghl\/reimbursement",
        "name": "franchise.report.ghl.reimbursement.index"
    },
    {
        "uri": "franchise\/report\/ghl\/reimbursement\/list",
        "name": "franchise.report.ghl.reimbursement.list"
    },
    {
        "uri": "franchise\/report\/ghl\/reimbursement\/search\/meta",
        "name": "franchise.report.ghl.reimbursement.search.meta"
    },
    {
        "uri": "franchise\/report\/ghl\/reimbursement\/export\/{type}\/{detail}",
        "name": "franchise.report.ghl.reimbursement.export"
    },
    {
        "uri": "franchise\/report\/cash-adjustment",
        "name": "franchise.report.cash_adjustments.index"
    },
    {
        "uri": "franchise\/report\/cash-adjustment\/all",
        "name": "franchise.report.cash_adjustments.all"
    },
    {
        "uri": "franchise\/report\/cash-adjustment\/summary",
        "name": "franchise.report.cash_adjustments.summary"
    },
    {
        "uri": "franchise\/report\/cash-adjustment\/export\/{type}",
        "name": "franchise.report.cash_adjustments.export"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-movement",
        "name": "franchise.report.fuel.movement"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-movement\/data",
        "name": "franchise.report.fuel.movement.data"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-movement\/export",
        "name": "franchise.report.fuel.movement.export"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-movement-eod\/data",
        "name": "franchise.report.fuel.movement-eod.data"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-movement-eod\/export",
        "name": "franchise.report.fuel.movement-eod.export"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales",
        "name": "franchise.report.fuel.gas_sales"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/{id}\/summary",
        "name": "franchise.report.fuel.summary"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/dispenser",
        "name": "franchise.report.fuel.dispenser"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/salesByMop",
        "name": "franchise.report.fuel.salesByMop"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/salesByPmr",
        "name": "franchise.report.fuel.salesByPmr"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/fuel",
        "name": "franchise.report.fuel.fuel"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/graph",
        "name": "franchise.report.fuel.graph"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/meta",
        "name": "franchise.report.fuel.fuel.meta"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/export",
        "name": "franchise.report.fuel.gas_report"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/export-mop",
        "name": "franchise.report.fuel.export_mop"
    },
    {
        "uri": "franchise\/report\/fuel\/gas-sales\/export-pmr",
        "name": "franchise.report.fuel.export_pmr"
    },
    {
        "uri": "franchise\/report\/fuel\/tank-sales",
        "name": "franchise.report.fuel.tank_sales"
    },
    {
        "uri": "franchise\/report\/fuel\/tank-sales\/list",
        "name": "franchise.report.fuel.tank_sales.list"
    },
    {
        "uri": "franchise\/report\/fuel\/tank-sales\/meta",
        "name": "franchise.report.fuel.tank_sales.meta"
    },
    {
        "uri": "franchise\/report\/fuel\/pump-test",
        "name": "franchise.report.fuel.pump-test"
    },
    {
        "uri": "franchise\/report\/fuel\/pump-test\/pump-test",
        "name": "franchise.report.fuel.pump-test.getPumpTest"
    },
    {
        "uri": "franchise\/report\/fuel\/pump-test\/search\/meta",
        "name": "franchise.report.fuel.pump-test.meta"
    },
    {
        "uri": "franchise\/report\/fuel\/pump-test\/pump-test-list",
        "name": "franchise.report.fuel.pump-test.filter"
    },
    {
        "uri": "franchise\/report\/fuel\/pump-test\/authorised-staff",
        "name": "franchise.report.fuel.pump-test.auth.staff"
    },
    {
        "uri": "franchise\/report\/fuel\/pump-test\/export\/{type}",
        "name": "franchise.report.fuel.pump-test.export"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction",
        "name": "franchise.report.fuel.fuel-transaction"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/search\/meta",
        "name": "franchise.report.fuel.fuel-transaction.meta"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/api\/daily-report",
        "name": "franchise.report.fuel.fuel-transaction.daily-report"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/api\/monthly-report",
        "name": "franchise.report.fuel.fuel-transaction.monthly-report"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/api\/daily-summary",
        "name": "franchise.report.fuel.fuel-transaction.daily-summary"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/api\/monthly-summary",
        "name": "franchise.report.fuel.fuel-transaction.monthly-summary"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/api\/export\/{date_type}\/{type}",
        "name": "franchise.report.fuel.fuel-transaction.export"
    },
    {
        "uri": "franchise\/report\/fuel\/fuel-transaction\/export\/v2\/{type}",
        "name": "franchise.report.fuel.fuel-transaction.export.v2"
    },
    {
        "uri": "franchise\/report\/fuel\/pttm",
        "name": "franchise.report.fuel.pttm"
    },
    {
        "uri": "franchise\/report\/fuel\/pttm\/api\/mapping",
        "name": "franchise.report.fuel.pttm.mapping"
    },
    {
        "uri": "franchise\/report\/fuel\/pttm\/api\/export\/{type}",
        "name": "franchise.report.fuel.pttm.export"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2",
        "name": "franchise.report.daily_sales_v2.index"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/{id}",
        "name": "franchise.report.daily_sales_v2.show"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/card\/{id}",
        "name": "franchise.report.daily_sales_v2.show-card"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/card-edc\/{id}",
        "name": "franchise.report.daily_sales_v2.show-card-edc"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/show\/{id}",
        "name": "franchise.report.daily_sales_v2.showdailysale"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/card\/show\/{id}",
        "name": "franchise.report.daily_sales_v2.showcardsale"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/card-edc\/show\/{id}",
        "name": "franchise.report.daily_sales_v2.showcardedcsale"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/export\/{type}",
        "name": "franchise.report.daily_sales_v2.exportAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/card\/{id}\/export\/{type}",
        "name": "franchise.report.daily_sales_v2.exportCardAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/card-edc\/{id}\/export\/{type}",
        "name": "franchise.report.daily_sales_v2.exportCardEdcAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/dailysales\/export\/{id}\/{timezoneDevice}",
        "name": "franchise.report.daily_sales_v2.exportDailyAsFile"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/list",
        "name": "franchise.report.daily_sales_v2.dailySalesList"
    },
    {
        "uri": "franchise\/report\/daily-sales-v2\/search\/meta",
        "name": "franchise.report.daily_sales_v2.search.meta"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion",
        "name": "franchise.report.non_fuel.shell.app.promotion.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/summary\/total-loyalty-transactions",
        "name": "franchise.report.non_fuel.shell.app.promotion.summary.totalLoyaltyTransactions"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/summary\/total-voucher-redeemed",
        "name": "franchise.report.non_fuel.shell.app.promotion.summary.totalVoucherRedeemed"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/summary\/total-voucher-value",
        "name": "franchise.report.non_fuel.shell.app.promotion.summary.totalVoucherValue"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/summary\/total-promotion-quantity-sold",
        "name": "franchise.report.non_fuel.shell.app.promotion.summary.totalPromotionQuantitySold"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/summary\/total-promotion-sales",
        "name": "franchise.report.non_fuel.shell.app.promotion.summary.totalPromotionSales"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/summary\/total-promotion-sold",
        "name": "franchise.report.non_fuel.shell.app.promotion.summary.totalPromotionSold"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/voucher",
        "name": "franchise.report.non_fuel.shell.app.promotion.voucher"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/promotion",
        "name": "franchise.report.non_fuel.shell.app.promotion.promotion"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/promotion\/product",
        "name": "franchise.report.non_fuel.shell.app.promotion.promotion.product"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/export\/voucher\/{type}",
        "name": "franchise.report.non_fuel.shell.app.promotion.voucher.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/export\/promotion\/{type}",
        "name": "franchise.report.non_fuel.shell.app.promotion.promotion.export"
    },
    {
        "uri": "franchise\/report\/non-fuel\/shell\/app\/promotion\/export\/promotion\/product\/{type}",
        "name": "franchise.report.non_fuel.shell.app.promotion.promotion.product.export"
    },
    {
        "uri": "franchise\/report\/staff-attendance",
        "name": "franchise.report.staff_attendance.index"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/attendance-list",
        "name": "franchise.report.staff_attendance.attendance_list"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/attendance-summary",
        "name": "franchise.report.staff_attendance.attendance_summary"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/export-attendance\/{type}",
        "name": "franchise.report.staff_attendance.export_attendance"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/export-attendance-summary\/{type}",
        "name": "franchise.report.staff_attendance.export_attendance_summary"
    },
    {
        "uri": "franchise\/report\/staff-attendance\/export-attendance-individual\/{staff_id}\/{type}",
        "name": "franchise.report.staff_attendance.export_attendance_individual"
    },
    {
        "uri": "franchise\/report\/reimbursement",
        "name": "franchise.report.reimbursement.index"
    },
    {
        "uri": "franchise\/report\/reimbursement\/card-sales",
        "name": "franchise.report.reimbursement.card.sales"
    },
    {
        "uri": "franchise\/report\/reimbursement\/export\/{type}",
        "name": "franchise.report.reimbursement.export"
    },
    {
        "uri": "franchise\/report\/reimbursement\/search\/meta",
        "name": "franchise.report.reimbursement.search.meta"
    },
    {
        "uri": "franchise\/report\/reimbursement\/terminal-list",
        "name": "franchise.report.reimbursement.terminal-list"
    },
    {
        "uri": "franchise\/report\/shell\/app\/reimbursement",
        "name": "franchise.report.shell.app.reimbursement.index"
    },
    {
        "uri": "franchise\/report\/shell\/app\/reimbursement\/list",
        "name": "franchise.report.shell.app.reimbursement.list"
    },
    {
        "uri": "franchise\/report\/shell\/app\/reimbursement\/export\/{type}",
        "name": "franchise.report.shell.app.reimbursement.export"
    },
    {
        "uri": "franchise\/report\/voided-sales",
        "name": "franchise.report.voidedsales.index"
    },
    {
        "uri": "franchise\/report\/voided-sales\/voided-sales",
        "name": "franchise.report.voidedsales.voidedsales"
    },
    {
        "uri": "franchise\/report\/voided-sales\/voided-orders",
        "name": "franchise.report.voidedsales.voided_orders"
    },
    {
        "uri": "franchise\/report\/voided-sales\/export-voided-orders\/{type}",
        "name": "franchise.report.voidedsales.voided_orders_export"
    },
    {
        "uri": "franchise\/report\/voided-sales\/aborted-fuels",
        "name": "franchise.report.voidedsales.abortedfuels"
    },
    {
        "uri": "franchise\/report\/voided-sales\/aborted-fuels\/export\/{type}",
        "name": "franchise.report.voidedsales.abortedfuels.export"
    },
    {
        "uri": "franchise\/report\/voided-sales\/{id}\/summary",
        "name": "franchise.report.voidedsales.getSummary"
    },
    {
        "uri": "franchise\/report\/voided-sales\/export\/{type}",
        "name": "franchise.report.voidedsales.exportAsFile"
    },
    {
        "uri": "franchise\/report\/voided-sales\/search\/meta",
        "name": "franchise.report.voidedsales.search.meta"
    },
    {
        "uri": "franchise\/report\/voided-sales\/search\/type",
        "name": "franchise.report.voidedsales.search.type"
    },
    {
        "uri": "franchise\/meta",
        "name": "franchise.meta.store"
    },
    {
        "uri": "franchise\/meta\/{id}\/{module}",
        "name": "franchise.meta.list-data"
    },
    {
        "uri": "franchise\/checkout\/{id}",
        "name": "franchise.checkout.show"
    },
    {
        "uri": "franchise\/card",
        "name": "franchise.setting.card.index"
    },
    {
        "uri": "franchise\/card",
        "name": "franchise.setting.card.store"
    },
    {
        "uri": "franchise\/card\/{id}",
        "name": "franchise.setting.card.update"
    },
    {
        "uri": "franchise\/measurement",
        "name": "franchise.inventory.measurement.index"
    },
    {
        "uri": "franchise\/measurement\/list",
        "name": "franchise.inventory.measurement.list"
    },
    {
        "uri": "franchise\/measurement\/submit",
        "name": "franchise.inventory.measurement.submit"
    },
    {
        "uri": "franchise\/measurement\/delete",
        "name": "franchise.inventory.measurement.delete"
    },
    {
        "uri": "franchise\/measurement\/package_configuration\/list",
        "name": "franchise.inventory.measurement.package_configuration.list"
    },
    {
        "uri": "franchise\/measurement\/package_configuration\/submit",
        "name": "franchise.inventory.measurement.package_configuration.submit"
    },
    {
        "uri": "franchise\/measurement\/package_configuration\/delete",
        "name": "franchise.inventory.measurement.package_configuration.delete"
    },
    {
        "uri": "franchise\/zone",
        "name": "franchise.zone.index"
    },
    {
        "uri": "franchise\/zone\/{id}",
        "name": "franchise.zone.show"
    },
    {
        "uri": "franchise\/zone",
        "name": "franchise.zone.store"
    },
    {
        "uri": "franchise\/zone",
        "name": "franchise.zone.delete"
    },
    {
        "uri": "franchise\/zone\/{id}",
        "name": "franchise.zone.update"
    },
    {
        "uri": "franchise\/report\/non-fuel\/royalty",
        "name": "franchise.report.non_fuel.royalty.index"
    },
    {
        "uri": "franchise\/report\/non-fuel\/royalty\/{id}",
        "name": "franchise.report.non_fuel.royalty.royalty"
    },
    {
        "uri": "franchise\/royalty\/search\/outlet\/meta",
        "name": "franchise.royalty.search.outlet"
    },
    {
        "uri": "franchise\/royalty\/search\/royalty\/meta",
        "name": "franchise.royalty.search.meta"
    },
    {
        "uri": "franchise\/royalty\/search\/tier\/meta",
        "name": "franchise.royalty.search.tier"
    },
    {
        "uri": "franchise\/royalty\/stations",
        "name": "franchise.royalty.stations"
    },
    {
        "uri": "franchise\/royalty\/station\/{id}",
        "name": "franchise.royalty.station.list"
    },
    {
        "uri": "franchise\/royalty\/station\/store",
        "name": "franchise.royalty.station.store"
    },
    {
        "uri": "franchise\/royalty\/tiers",
        "name": "franchise.royalty.tiers"
    },
    {
        "uri": "franchise\/royalty\/tier\/store",
        "name": "franchise.royalty.tier.store"
    },
    {
        "uri": "franchise\/royalty\/{id}",
        "name": "franchise.royalty.tier.update"
    },
    {
        "uri": "franchise\/royalty",
        "name": "franchise.royalty.tier.delete"
    },
    {
        "uri": "franchise\/reports.royalty\/royalty-income\/{id}",
        "name": "franchise.reports.royalty.getRoyaltyIncome"
    },
    {
        "uri": "franchise\/reports.royalty\/station",
        "name": "franchise.reports.royalty.station.list"
    },
    {
        "uri": "franchise\/reports.royalty\/station-list\/{id}",
        "name": "franchise.reports.royalty.station-list"
    },
    {
        "uri": "franchise\/reports.royalty\/station\/{id}",
        "name": "franchise.reports.royalty.outlet.detail"
    },
    {
        "uri": "franchise\/reports.royalty\/tier",
        "name": "franchise.reports.royalty.tiers"
    },
    {
        "uri": "franchise\/reports.royalty\/{id}",
        "name": "franchise.reports.royalty.tier"
    },
    {
        "uri": "franchise\/reports.royalty\/stations",
        "name": "franchise.reports.royalty.tier_station.list"
    },
    {
        "uri": "franchise\/reports.royalty\/export\/{type}\/tier",
        "name": "franchise.reports.royalty.exportStationAsFile"
    },
    {
        "uri": "franchise\/reports.royalty\/export\/{type}\/station",
        "name": "franchise.reports.royalty.exportStationSalesAsFile"
    },
    {
        "uri": "franchise\/reports.royalty\/export\/{type}\/royalty",
        "name": "franchise.reports.royalty.exportRoyaltyAsFile"
    },
    {
        "uri": "franchise\/reports.royalty\/export\/{type}\/station-list",
        "name": "franchise.reports.royalty.exportStationTierList"
    },
    {
        "uri": "franchise\/reports.royalty\/export\/{type}",
        "name": "franchise.reports.royalty.exportTemplate"
    },
    {
        "uri": "franchise\/changeset",
        "name": "franchise.changeset.index"
    },
    {
        "uri": "franchise\/changeset\/{id}",
        "name": "franchise.changeset.show"
    },
    {
        "uri": "franchise\/changeset\/{id}\/products",
        "name": "franchise.changeset.products"
    },
    {
        "uri": "franchise\/changeset\/{id}\/stations",
        "name": "franchise.changeset.stations"
    },
    {
        "uri": "franchise\/changeset\/edit\/{id}",
        "name": "franchise.changeset.edit"
    },
    {
        "uri": "franchise\/changeset\/{id}\/station\/{station}",
        "name": "franchise.changeset.outlet.products"
    },
    {
        "uri": "franchise\/changeset\/{id}\/export\/{type}\/products",
        "name": "franchise.changeset.export.products"
    },
    {
        "uri": "franchise\/changeset\/{id}\/export\/{type}\/stations",
        "name": "franchise.changeset.export.stations"
    },
    {
        "uri": "franchise\/changeset\/{id}",
        "name": "franchise.changeset.update"
    },
    {
        "uri": "franchise\/changeset\/{id}\/publish",
        "name": "franchise.changeset.publish"
    },
    {
        "uri": "franchise\/changeset",
        "name": "franchise.changeset.store"
    },
    {
        "uri": "franchise\/changeset\/{id}\/products",
        "name": "franchise.changeset.deleteProduct"
    },
    {
        "uri": "franchise\/changeset\/{id}\/changeset",
        "name": "franchise.changeset.deleteChangeset"
    },
    {
        "uri": "franchise\/changeset\/{id}\/products_pool",
        "name": "franchise.changeset.products_pool"
    },
    {
        "uri": "franchise\/changeset\/{id}\/products_count",
        "name": "franchise.changeset.products_count"
    },
    {
        "uri": "franchise\/changeset\/{id}\/batch_add",
        "name": "franchise.changeset.batch_add"
    },
    {
        "uri": "franchise\/changeset\/{id}\/entry",
        "name": "franchise.changeset.entry.save"
    },
    {
        "uri": "inventory\/cost-good-sold",
        "name": "inventory.cost.good.sold.index"
    },
    {
        "uri": "inventory\/cost-good-sold\/list",
        "name": "inventory.cost.good.sold.list"
    },
    {
        "uri": "inventory\/cost-good-sold\/export\/{type}",
        "name": "inventory.cost.good.sold.export"
    },
    {
        "uri": "inventory\/cost-good-sold\/summary",
        "name": "inventory.cost.good.sold.summary"
    },
    {
        "uri": "inventory\/distributor",
        "name": "inventory.distributor.index"
    },
    {
        "uri": "inventory\/distributor\/list",
        "name": "inventory.distributor.list"
    },
    {
        "uri": "inventory\/distributor\/show\/{id}",
        "name": "inventory.distributor.show"
    },
    {
        "uri": "inventory\/distributor\/outlet\/list\/{id}",
        "name": "inventory.distributor.outlet.list"
    },
    {
        "uri": "inventory\/distributor\/{id}\/supplier\/product\/list",
        "name": "inventory.distributor.supplier.product.list"
    },
    {
        "uri": "inventory\/distributor\/{id}\/supplier\/product\/list\/export\/{type}",
        "name": "inventory.distributor.supplier.product.list.export"
    },
    {
        "uri": "inventory\/distributor\/outlet\/{outletId}",
        "name": "inventory.distributor.outlet.distributors"
    },
    {
        "uri": "inventory\/distributor\/update\/outlet",
        "name": "inventory.distributor.update.outlet"
    },
    {
        "uri": "inventory\/distributor\/export\/{type}",
        "name": "inventory.distributor.export"
    },
    {
        "uri": "inventory\/distributor\/create",
        "name": "inventory.distributor.create"
    },
    {
        "uri": "inventory\/distributor\/update",
        "name": "inventory.distributor.update"
    },
    {
        "uri": "inventory\/distributor\/update\/suppliers",
        "name": "inventory.distributor.update.suppliers"
    },
    {
        "uri": "inventory\/distributor\/delete",
        "name": "inventory.distributor.delete"
    },
    {
        "uri": "inventory\/audit-trail",
        "name": "inventory.audit-trail.index"
    },
    {
        "uri": "inventory\/audit-trail\/list",
        "name": "inventory.audit-trail.list"
    },
    {
        "uri": "inventory\/audit-trail\/export\/{type}",
        "name": "inventory.audit-trail.exportAsFile"
    },
    {
        "uri": "inventory\/stock-check",
        "name": "inventory.stock-check.index"
    },
    {
        "uri": "inventory\/stock-check\/list",
        "name": "inventory.stock-check.list"
    },
    {
        "uri": "inventory\/stock-check\/show\/{id}",
        "name": "inventory.stock-check.show"
    },
    {
        "uri": "inventory\/stock-check\/variance\/list",
        "name": "inventory.stock-check.variance-list"
    },
    {
        "uri": "inventory\/stock-check\/product\/list\/{id}",
        "name": "inventory.stock-check.product-list"
    },
    {
        "uri": "inventory\/stock-check\/export\/{id}\/{type}",
        "name": "inventory.stock-check.exportAsFile"
    },
    {
        "uri": "inventory\/stock-check\/export\/main\/{type}",
        "name": "inventory.stock-check.exportListAsFile"
    },
    {
        "uri": "inventory\/stock-check\/create",
        "name": "inventory.stock-check.create"
    },
    {
        "uri": "inventory\/stock-check\/update",
        "name": "inventory.stock-check.update"
    },
    {
        "uri": "inventory\/stock-check\/delete",
        "name": "inventory.stock-check.delete"
    },
    {
        "uri": "inventory\/stock-check\/completed",
        "name": "inventory.stock-check.completed"
    },
    {
        "uri": "inventory\/unscanned-stock\/unscanned\/item\/categories\/{id}",
        "name": "inventory.unscanned-stock.unscanned.item.categories"
    },
    {
        "uri": "inventory\/unscanned-stock\/sub\/unscanned\/items\/{stock_movement_id}\/{parent_id}\/{search?}",
        "name": "inventory.unscanned-stock.sub.unscanned.items"
    },
    {
        "uri": "inventory\/unscanned-stock\/has\/unscanned\/items\/session\/{id}",
        "name": "inventory.unscanned-stock.has.unscanned.items.session"
    },
    {
        "uri": "inventory\/unscanned-stock\/get\/station\/sales\/categories\/{franchise_id}\/{outlet_id}\/{stock_movement_id}",
        "name": "inventory.unscanned-stock.get.station.sales.categories"
    },
    {
        "uri": "inventory\/unscanned-stock\/export\/unscanned\/items\/{stock_movement_id}\/{type}",
        "name": "inventory.unscanned-stock.unscanned.items.exportAsFile"
    },
    {
        "uri": "inventory\/unscanned-stock\/delete\/unscanned\/item\/{id}",
        "name": "inventory.unscanned-stock.delete.unscanned.item"
    },
    {
        "uri": "inventory\/unscanned-stock\/show\/unscanned\/items",
        "name": "inventory.unscanned-stock.show.unscanned.items"
    },
    {
        "uri": "inventory\/unscanned-stock-product\/save\/unscanned\/items",
        "name": "inventory.unscanned-stock-product.save.unscanned.items"
    },
    {
        "uri": "inventory\/stock-return",
        "name": "inventory.stock-return.index"
    },
    {
        "uri": "inventory\/stock-return\/list",
        "name": "inventory.stock-return.list"
    },
    {
        "uri": "inventory\/stock-return\/show\/{id}",
        "name": "inventory.stock-return.show"
    },
    {
        "uri": "inventory\/stock-return\/product\/list\/{id}",
        "name": "inventory.stock-return.product-list"
    },
    {
        "uri": "inventory\/stock-return\/export\/{id}\/{type}",
        "name": "inventory.stock-return.exportAsFile"
    },
    {
        "uri": "inventory\/stock-return\/export\/main\/{type}",
        "name": "inventory.stock-return.exportListAsFile"
    },
    {
        "uri": "inventory\/stock-return\/create",
        "name": "inventory.stock-return.create"
    },
    {
        "uri": "inventory\/stock-return\/update",
        "name": "inventory.stock-return.update"
    },
    {
        "uri": "inventory\/stock-return\/delete",
        "name": "inventory.stock-return.delete"
    },
    {
        "uri": "inventory\/stock-return\/returned",
        "name": "inventory.stock-return.returned"
    },
    {
        "uri": "inventory\/stock-fifo",
        "name": "inventory.stock-fifo.index"
    },
    {
        "uri": "inventory\/stock-fifo\/list",
        "name": "inventory.stock-fifo.list"
    },
    {
        "uri": "inventory\/monitor",
        "name": "inventory.monitor.index"
    },
    {
        "uri": "inventory\/monitor\/list",
        "name": "inventory.monitor.list"
    },
    {
        "uri": "inventory\/monitor\/stock\/movement\/product\/list\/{stock_id}",
        "name": "inventory.monitor.stock-movement-product-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/batch\/list\/{stock_id}",
        "name": "inventory.monitor.stock-batch-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/cache\/list\/{stock_id}",
        "name": "inventory.monitor.stock-cache-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/deduction\/list\/{stock_id}",
        "name": "inventory.monitor.stock-deduction-list"
    },
    {
        "uri": "inventory\/monitor\/stock\/deduction\/cache\/list\/{stock_id}",
        "name": "inventory.monitor.stock-deduction-cache-list"
    },
    {
        "uri": "inventory\/stock-batch\/list\/{stock_id}",
        "name": "inventory.stock-batch.list"
    },
    {
        "uri": "inventory\/stock-movement\/search\/meta\/{supplier}",
        "name": "inventory.stock-movement.search.meta"
    },
    {
        "uri": "inventory\/stock-movement\/search\/status",
        "name": "inventory.stock-movement.search.status"
    },
    {
        "uri": "inventory\/product\/selector",
        "name": "inventory.product.selector"
    },
    {
        "uri": "inventory\/stock-transfer",
        "name": "inventory.stock-transfer.index"
    },
    {
        "uri": "inventory\/stock-transfer\/selector",
        "name": "inventory.stock-transfer.selector"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/list",
        "name": "inventory.stock-transfer.out.list"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/info\/{id}",
        "name": "inventory.stock-transfer.out.info"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/product\/list\/{id}",
        "name": "inventory.stock-transfer.out.product.list"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/create",
        "name": "inventory.stock-transfer.out.create"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/update",
        "name": "inventory.stock-transfer.out.update"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/delete",
        "name": "inventory.stock-transfer.out.delete"
    },
    {
        "uri": "inventory\/stock-transfer\/out\/commit",
        "name": "inventory.stock-transfer.out.commit"
    },
    {
        "uri": "inventory\/stock-transfer\/in\/list",
        "name": "inventory.stock-transfer.in.list"
    },
    {
        "uri": "inventory\/stock-transfer\/in\/info\/{id}",
        "name": "inventory.stock-transfer.in.info"
    },
    {
        "uri": "inventory\/stock-transfer\/in\/product\/list\/{id}",
        "name": "inventory.stock-transfer.in.product.list"
    },
    {
        "uri": "inventory\/stock-transfer\/in\/commit",
        "name": "inventory.stock-transfer.in.commit"
    },
    {
        "uri": "inventory\/stock-cost",
        "name": "inventory.stock-cost.index"
    },
    {
        "uri": "inventory\/stock-cost\/list",
        "name": "inventory.stock-cost.list"
    },
    {
        "uri": "inventory\/stock-cost\/summary",
        "name": "inventory.stock-cost.summary"
    },
    {
        "uri": "inventory\/stock-cost\/export\/{type}",
        "name": "inventory.stock-cost.exportAsFile"
    },
    {
        "uri": "inventory\/stock-cost\/search\/meta",
        "name": "inventory.stock-cost.search.meta"
    },
    {
        "uri": "inventory\/stock-cost\/check\/status\/opening-stock",
        "name": "inventory.stock-cost.check.status.opening-stock"
    },
    {
        "uri": "inventory\/stock-cost\/export-transfer\/{type}",
        "name": "inventory.stock-cost.exportForTransfer"
    },
    {
        "uri": "inventory\/sync",
        "name": "inventory.sync.index"
    },
    {
        "uri": "inventory\/sync\/sync\/check\/{id}",
        "name": "inventory.sync.sync-check"
    },
    {
        "uri": "inventory\/sync\/{id}",
        "name": "inventory.sync.sync"
    },
    {
        "uri": "inventory\/stock",
        "name": "inventory.stock.index"
    },
    {
        "uri": "inventory\/stock\/list",
        "name": "inventory.stock.list"
    },
    {
        "uri": "inventory\/stock\/show\/{unique_id}",
        "name": "inventory.stock.show"
    },
    {
        "uri": "inventory\/stock\/migrate",
        "name": "inventory.stock.migrate"
    },
    {
        "uri": "inventory\/stock\/download\/missing\/product",
        "name": "inventory.stock.download.missing.product"
    },
    {
        "uri": "inventory\/stock\/export\/{type}",
        "name": "inventory.stock.exportAsFile"
    },
    {
        "uri": "inventory\/stock\/update",
        "name": "inventory.stock.update"
    },
    {
        "uri": "inventory\/stock\/selector",
        "name": "inventory.stock.selector"
    },
    {
        "uri": "inventory\/stock\/supplier\/selector",
        "name": "inventory.stock.supplier.selector"
    },
    {
        "uri": "inventory\/stock\/price-checker\/{outlet_id}\/{code}\/{unique_id?}",
        "name": "inventory.stock.price-checker"
    },
    {
        "uri": "inventory\/supplier",
        "name": "inventory.supplier.index"
    },
    {
        "uri": "inventory\/supplier\/list",
        "name": "inventory.supplier.list"
    },
    {
        "uri": "inventory\/supplier\/{id}",
        "name": "inventory.supplier.show"
    },
    {
        "uri": "inventory\/supplier\/export\/{type}\/{id?}",
        "name": "inventory.supplier.export"
    },
    {
        "uri": "inventory\/supplier\/distributors\/{supplierId}",
        "name": "inventory.supplier.distributors"
    },
    {
        "uri": "inventory\/supplier\/create",
        "name": "inventory.supplier.create"
    },
    {
        "uri": "inventory\/supplier\/update",
        "name": "inventory.supplier.update"
    },
    {
        "uri": "inventory\/supplier\/delete",
        "name": "inventory.supplier.delete"
    },
    {
        "uri": "inventory\/supplier\/stock\/list",
        "name": "inventory.supplier.stock.list"
    },
    {
        "uri": "inventory\/supplier\/stock\/add",
        "name": "inventory.supplier.stock.add"
    },
    {
        "uri": "inventory\/supplier\/stock\/update",
        "name": "inventory.supplier.stock.update"
    },
    {
        "uri": "inventory\/supplier\/stock\/delete",
        "name": "inventory.supplier.stock.delete"
    },
    {
        "uri": "inventory\/supplier\/product\/list",
        "name": "inventory.supplier.product.list"
    },
    {
        "uri": "inventory\/supplier\/product\/add",
        "name": "inventory.supplier.product.add"
    },
    {
        "uri": "inventory\/supplier\/product\/update",
        "name": "inventory.supplier.product.update"
    },
    {
        "uri": "inventory\/supplier\/product\/delete",
        "name": "inventory.supplier.product.delete"
    },
    {
        "uri": "inventory\/stock-receive",
        "name": "inventory.stock-receive.index"
    },
    {
        "uri": "inventory\/stock-receive\/list",
        "name": "inventory.stock-receive.list"
    },
    {
        "uri": "inventory\/stock-receive\/show\/{id}",
        "name": "inventory.stock-receive.show"
    },
    {
        "uri": "inventory\/stock-receive\/product\/list\/{id}",
        "name": "inventory.stock-receive.product-list"
    },
    {
        "uri": "inventory\/stock-receive\/export\/{id}\/{type}",
        "name": "inventory.stock-receive.exportAsFile"
    },
    {
        "uri": "inventory\/stock-receive\/export\/main\/{type}",
        "name": "inventory.stock-receive.exportListAsFile"
    },
    {
        "uri": "inventory\/stock-receive\/create",
        "name": "inventory.stock-receive.create"
    },
    {
        "uri": "inventory\/stock-receive\/update",
        "name": "inventory.stock-receive.update"
    },
    {
        "uri": "inventory\/stock-receive\/delete",
        "name": "inventory.stock-receive.delete"
    },
    {
        "uri": "inventory\/stock-receive\/received",
        "name": "inventory.stock-receive.received"
    },
    {
        "uri": "inventory\/eod-report\/{id}",
        "name": "inventory.eod.report.list"
    },
    {
        "uri": "inventory\/eod-report\/export\/{id}\/{type}",
        "name": "inventory.eod.report.export"
    },
    {
        "uri": "inventory",
        "name": "inventory.index"
    },
    {
        "uri": "inventory\/dashboard",
        "name": "inventory.dashboard"
    },
    {
        "uri": "inventory\/dashboard\/export\/{type}",
        "name": "inventory.dashboard.exportAsFile"
    },
    {
        "uri": "inventory\/dashboard\/summary",
        "name": "inventory.dashboard.summary"
    },
    {
        "uri": "inventory\/dashboard\/supplier\/distribution",
        "name": "inventory.dashboard.supplier-distribution"
    },
    {
        "uri": "inventory\/dashboard\/inventory\/asset",
        "name": "inventory.dashboard.inventory-asset"
    },
    {
        "uri": "inventory\/dashboard\/inventory\/category\/asset",
        "name": "inventory.dashboard.inventory-category-asset"
    },
    {
        "uri": "inventory\/dashboard\/supplier\/qty",
        "name": "inventory.dashboard.top-supplier-qty"
    },
    {
        "uri": "inventory\/dashboard\/supplier\/cost",
        "name": "inventory.dashboard.top-supplier-cost"
    },
    {
        "uri": "inventory\/fe\/supplier\/product\/list",
        "name": "frontend.inventory.supplier.product.list"
    },
    {
        "uri": "inventory\/fe\/supplier\/product\/add",
        "name": "frontend.inventory.supplier.product.add"
    },
    {
        "uri": "inventory\/fe\/supplier\/product\/update",
        "name": "frontend.inventory.supplier.product.update"
    },
    {
        "uri": "inventory\/fe\/supplier\/product\/delete",
        "name": "frontend.inventory.supplier.product.delete"
    }
],
            prefix: '',

            route : function (name, parameters, route) {
                route = route || this.getByName(name);

                if ( ! route ) {
                    return undefined;
                }

                return this.toRoute(route, parameters);
            },

            url: function (url, parameters) {
                parameters = parameters || [];

                var uri = url + '/' + parameters.join('/');

                return this.getCorrectUrl(uri);
            },

            toRoute : function (route, parameters) {
                var uri = this.replaceNamedParameters(route.uri, parameters);
                var qs  = this.getRouteQueryString(parameters);

                if (this.absolute && this.isOtherHost(route)){
                    return "//" + route.host + "/" + uri + qs;
                }

                return this.getCorrectUrl(uri + qs);
            },

            isOtherHost: function (route){
                return route.host && route.host != window.location.hostname;
            },

            replaceNamedParameters : function (uri, parameters) {
                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {
                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                // Strip out any optional parameters that were not given
                uri = uri.replace(/\/\{.*?\?\}/g, '');

                return uri;
            },

            getRouteQueryString : function (parameters) {
                var qs = [];
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        qs.push(key + '=' + parameters[key]);
                    }
                }

                if (qs.length < 1) {
                    return '';
                }

                return '?' + qs.join('&');
            },

            getByName : function (name) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].name === name) {
                        return this.routes[key];
                    }
                }
            },

            getByAction : function(action) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].action === action) {
                        return this.routes[key];
                    }
                }
            },

            getCorrectUrl: function (uri) {
                var url = this.prefix + '/' + uri.replace(/^\/?/, '');

                if ( ! this.absolute) {
                    return url;
                }

                return this.rootUrl.replace('/\/?$/', '') + url;
            }
        };

        var getLinkAttributes = function(attributes) {
            if ( ! attributes) {
                return '';
            }

            var attrs = [];
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    attrs.push(key + '="' + attributes[key] + '"');
                }
            }

            return attrs.join(' ');
        };

        var getHtmlLink = function (url, title, attributes) {
            title      = title || url;
            attributes = getLinkAttributes(attributes);

            return '<a href="' + url + '" ' + attributes + '>' + title + '</a>';
        };

        return {
            // Generate a url for a given controller action.
            // laroute.action('HomeController@getIndex', [params = {}])
            action : function (name, parameters) {
                parameters = parameters || {};

                return routes.route(name, parameters, routes.getByAction(name));
            },

            // Generate a url for a given named route.
            // laroute.route('routeName', [params = {}])
            route : function (route, parameters) {
                parameters = parameters || {};

                return routes.route(route, parameters);
            },

            // Generate a fully qualified URL to the given path.
            // laroute.route('url', [params = {}])
            url : function (route, parameters) {
                parameters = parameters || {};

                return routes.url(route, parameters);
            },

            // Generate a html link to the given url.
            // laroute.link_to('foo/bar', [title = url], [attributes = {}])
            link_to : function (url, title, attributes) {
                url = this.url(url);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given route.
            // laroute.link_to_route('route.name', [title=url], [parameters = {}], [attributes = {}])
            link_to_route : function (route, title, parameters, attributes) {
                var url = this.route(route, parameters);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given controller action.
            // laroute.link_to_action('HomeController@getIndex', [title=url], [parameters = {}], [attributes = {}])
            link_to_action : function(action, title, parameters, attributes) {
                var url = this.action(action, parameters);

                return getHtmlLink(url, title, attributes);
            }

        };

    }).call(this);

    /**
     * Expose the class either via AMD, CommonJS or the global object
     */
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return laroute;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = laroute;
    }
    else {
        window.laroute = laroute;
    }

}).call(this);




// WEBPACK FOOTER //
// ./resources/assets/js/laroute.js